export const TRANSLATIONS_EN = {
  welcome: "Welcome!",
  welcome1: "To keep connected with us please login with your personal info",
  loginTitle: "Login",
  signupTitle: "Company Sign Up",
  signup: "Sign Up",
  home: "Home",
  search: "search",
  ok: "Ok",
  add: "Add",
  back: "Back",
  send: "Send",
  cancel: "Cancel",
  reset: "Reset",
  verify: "Verify",
  save: "Save",
  edit: "Edit",
  next: "Next",
  previous: "Previous",
  editNext: "Edit & Next",
  submit: "Submit",
  finish: "Finish",
  upload: "Upload",
  print: "Print",
  delete: "Delete",
  download: "Download",
  login: "Login",
  done: "Done",
  goTitle: "Let’s go!",
  go: "Go",
  go_to_app: "Go to App",
  back_to_app: "Back to my app",
  dashboard: "Dashboard",
  activityLog: "Activity Log",
  settings: "Settings",
  searchCompany: "Search Company",
  company_detail: "Company Detail",
  myCompany: "My Company",
  pl_pod: "POD Report",
  more_company_detail: "Share some more company details",
  keep_me_login: "Keep me logged in on this device",
  dont_have_acc: "Don't Have An Account Yet?",
  dont_verify_acc: "Didn't Verify Account Yet?",
  clickUp: "Already playing with Pharma Linkage?",
  login_successfull: "Succesfully login!",
  i_accept_the:
    "By creating this account I agree to Pharma Linkage business platform's",
  terms_and_conditions: " Terms and Conditions",
  facility: "Facility",
  manufacturingFacility: "Manufacturing Facility",
  viewManufacturingFacility: "View Manufacturing Facility",
  manufacturingFacilityName: "Mfg Facility Name",
  manufacturingSites: "Manufacturing Sites",
  sinceEstablished: "Since Established",
  managefacility: "Manage facility",
  addfacility: "Add facility",
  Facilitypresentation: "Facility Presentation",
  request_forCredentials: "Request for Credentials",
  register_confirm_msg: "Congratulations! Your compnay is registerd with us.",
  request_confirm_msg:
    "Your request is send to your company admin sucessfully.",
  sendRequest: "Send Request",
  verify_account: "Account Verification",
  verify_account_msg: "Please verify your email using verification code.",
  sendOTP: "Send OTP",
  emailed: "We just emailed you.",
  val_emailed: "Please Enter The Code We Emailed You.",
  confirmationCode: "Confirmation code",
  resendOTP: "Resend OTP",
  verify_successful: "Verification Successful!",
  request_successful: "Request Submitted Successfully!",
  request_successful_text:
    "Once your admin will approve request you will get password reset link on your email",
  congratultions: "Congratultions!",
  register_successful: "Welcome to Pharma Linkage.",
  app_info:
    "Streamline your deliveries with Hey Couriers! Our platform offers real-time tracking, optimized routes, and efficient communication to ensure your parcels arrive safely and on time. Perfect for businesses and individuals, Hey Couriers simplifies logistics and saves you time and money.",
  registration_successfull: "Registration Successfull!",
  val_Actual_Service_Time: "Please Enter Actual Service Time",
  pl_Actual_Service_Time: "Actual Service Time",
  val_Actual_Departure_Time: "Please Enter Actual Departure Time",
  pl_Actual_Departure_Time: "Actual Departure Time",
  registration_successfull_msg:
    "Please check your registered email for email verification.",
  forgot_password: "Forgot Password",
  forgot_password_msg:
    "Enter your email address and we will send you a link to reset your password",
  mailSent_successfull: "Mail has been sent to your registered email",
  resetLink_msg: "Reset password link sent to your registered email address",
  create_new_password: "Create New Password",
  changePassword_successfull: "Password changed!",
  changePassword_confirm_msg: "Your password has been changed successfully.",
  password_notconfirm_msg: "The two passwords that you entered do not match!",
  passsword_conditions:
    "Password should be minimum 8 characters, at least one letter and one number and one special character.",
  new_company_registration: "New Company Registration",
  manageUsers: "Manage users",
  manageUser: "Manage user",
  manageUsersRequest: "Manage Users Request",
  addUser: "Add User",
  changePassword: "Change Password",
  myProfie: "My Profile",
  PersonaInfo: "Personal info",
  profile_completenes: "Your Profile Completeness",
  manageCompany: "Manage Company",

  companyKeypersons: "Company Key Persons",
  company_corporatePresentation: "Company Corporate Presentation",
  uploadPDF: "Upload PPT/PDF",
  upload_fileSize: "Maximum file size: 2 MB",
  upload_fileSizeErr: "Image must smaller than 2 MB!",
  image_deleted_success: "Image Delete Successfully",
  videolink_URL: "Video link URL",
  Company_establishmentDate: "Company Establishment Date",
  no_of_manufacturingFacilities: "No. Of Manufacturing Facilities",
  employees: "Employees",
  updatePassword: "Update Password",
  userName: "UserName",
  firstName: "First Name",
  lastName: "Last Name",
  aboutMe: "About Me",
  company_name: "Company Name",
  businessLounge: " Business Lounge",
  whatsappNo: "Phone / WhatsApp No.",
  whatsapp_tooltip:
    "You can change your mobile number from profile edit option",
  verifyMobile: "Please verify your mobile",
  we_just_message_you: "We just message you.",
  enter_OTP_we_message_you: "Please enter the OTP we message you.",
  enterOTP: "Enter OTP",
  didnt_recieve_code: "Didn't Recieve OTP?",
  time_remaining: "Time Remaining",

  support: "Support",
  tickets: "Tickets",
  create_ticket: "Create Ticket",
  manage_ticket: "Manage Ticket",
  inprocess: "Inprocess",
  closed: "Closed",
  resolved: "Resolved",
  need_help: "Need some help?",
  need_help_msg1:
    "Check out our documentation or reach out to our support team via",
  need_help_msg2: "the form below. We’re happy to help!",
  describe_issue:
    "Please describe your question or issue in detail. include any attachments via URL (using a service like dropbox or google drive).",
  send_request: "Send Request",
  send_ticket_successfull: "Your Support Ticket Submitted!",
  ticket_mail_sent: "Our team will revert on it as soon as early",
  update_ticket_successfull: "Ticket updated successfully",

  sentInquiry: "Sent Inquiry",
  receivedInquiry: "Received Inquiry",
  inquiryList: "Inquiry list",

  concierge_service: "Concierge service",
  request_for_price: "Request for price",
  price_requested: "Price Requested",
  concierge_service_lbl1:
    "We provide a better linkage experience with our kit and have something for you as well. Choose the best suited kit plan.",
  sell_globally_service: "Sell Globally service with Pharma Linkage concierge",
  business_lounge_service:
    " Business Lounge service with Pharma Linkage concierge",
  bespoke_service: "Bespoke service with Pharma Linkage concierge",

  manageConciergeService: "Manage Concierge Service",
  addConciergeService: "Add Concierge Service",
  editConciergeService: "Edit Concierge Service",

  requestedConcierge: "Requested Concierge",
  purchasedConcierge: "Purchased Concierge",
  payment_fail: "Unfortunately, the payment for this order has failed",
  payment_successful:
    "Your payment was successful.  Your subscription will be updated in your account.",
  back_to_concierge: "back to concierge",
  buyNow: "Buy Now",
  invoice: "Invoice",
  download_sample_format: "Download Sample Format",
  upload_excel_option: "Bulk Upload",
  err_uploadSuccess: "Error in CSV Upload",
  msg_uploadSuccess: "CSV Uploaded Successfully",

  subscription: "Subscription",
  addSubscription: "Add Subscription",
  editSubscription: "Edit Subscription",

  purchasedsubscription: "Purchased Subscription",
  addPurchasedSubscription: "Add Purchased Subscription",
  editPurchasedSubscription: "Edit Purchased Subscription",

  companyList: "Company list",
  shortlistedCompany: "Shortlisted Company",

  //Login with OTP Page
  registered_email_label: "Please enter your registered email address",
  registered_mobile_label: "Please enter your registered mobile number",
  login_otp_label: "Login with OTP",
  //OTP verification Page
  otp_verification_label: "OTP Verification",
  otp_sent_mobile_label: "OTP has been sent on mobile",
  otp_sent_email_label: "OTP has been sent on Email",
  please_verify_below: " Please verify it below",
  //login Page
  welcome_back: "Welcome Back!",

  login_to_continue: "Login to continue",
  keep_me_logged_in_on_this_device: "Keep me logged in on this device",
  or: "OR",

  //pincode page
  pincode: "Pin Code",
  Street: "Street",
  import: "Import",
  drag_drop_csv_file: "Drag and drop your CSV file here",
  select_file_from_your_computer: "Or select file from your computer",
  maximum_file_size: "Maximum file size: 2mb (.csv)",
  download_sample_file: "Download Sample File From Here.",
  get_csv_sample: "Get Csv Sample",
  pl_archived_pincode: "Archived Pin Code",
  pl_archived_Street: "Archived Street",
  error_in_list_pincode: "Error in List Pincode",
  pl_add_pincode: "Add Pin Code",
  pl_add_street: "Add Street",
  //category page
  pl_category: "Category",
  label_category_name: "Category Name",
  pl_category_name: "Enter category name",
  val_category_name: "Please enter valid category name",
  label_description: "Description",
  pl_description: "Enter your description",
  archiveList: "Archive",
  archiveList1: "Archived Material Type",
  label_site1: "Select City",
  label_city: "City",
  pl_city: "City",
  pl_select_city: "Select City",
  pl_department: "Department",
  place_department: "Enter your department",
  pl_gst_no1: "Enter state GST number",

  archived_category: "Archived category",
  category_added_successfully: "Category added successfully",
  category_update_successfully: "Category updated successfully",
  error_in_add_category_list: "Error in add category list",
  error_in_list_category: "Error in list category",
  error_in_displaying_data: "Error in displaying data",
  category_restore_successfully: "Category restore successfully",
  category_restore_successfully4: "Category restored successfully",
  error_in_restore_category: "Error in restore category",
  category_archive_successfully: "Category archive successfully",
  category_archive_successfully4: "Category archived successfully",
  error_in_delete_category: "Error in delete category",
  error_in_update_category_list: "Error in updating category list",
  pl_add_category: "Add Category",
  pl_edit_category: "Edit Category",
  archived_vendor_onboarding1: "Archived Vendors",
  //Category Item Setting
  street_updated_successfully: "Street Updated Successfully",
  street_added_successfully: "Street Added Successfully",
  category_setting_added_successfully: "Category setting added successfully",
  category_setting_updated_successfully:
    "Category setting updated successfully",
  // AddZoneModel page
  zone_name_added_successfully: "Run name added successfully",
  zone_name_updated_successfully: "Run name updated successfully",
  driver_updated_successfully: "Driver Updated Successfully",
  driver_added_successfully: "Driver Added Successfully",
  zone_name_added_successfully2: "Run Added Successfully",
  zone_name_updated_successfully2: "Run Updated Successfully",
  area_name_added_successfully2: "Zone Added Successfully",
  area_name_updated_successfully2: "Zone Updated Successfully",
  pl_driver: "Driver",
  assign_driver: "Assign Driver",
  val_driver: "Please Select Driver",
  pl_assign_driver: "Select Driver",
  enter_state: "Enter State",
  state_name_added_successfully2: "State Added Successfully",
  state_name_updated_successfully2: "State Updated Successfully",
  error_in_adding_state_name: "Error in Adding State Name",
  // error_in_adding_state_name: "Error in adding state name",
  error_in_updating_state_name: "Error in Adding Run Name",
  error_in_updating_zone_name: "Error in Updating Run Name",
  zone_name_already_exist: "Run Name Already Exist",
  //Add Suburb
  val_suburb: "Enter valid suburb",
  pl_suburb: "Suburb",
  pl_select_subrub: "Select Suburb",
  val_select_subrub: "Please Select Suburb",
  suburb_updated_successfully: "Suburb Updated Successfully",
  suburb_added_successfully: "Suburb Added Successfully",
  pl_enter_suburb: "Enter Suburb",
  val_select_zone: "Please Select Run",
  val_select_area: "Please Select Zone",
  pl_enter_valid_subrub: "Please Enter Valid Suburb",
  //Zone List page

  error_in_zone_list: "Error in run list",
  error_in_area_list: "Error in zone list",
  state_archive_successfuly: "State Archived Successfully",
  error_in_archive_state: "Error In Archived State",
  zone_archive_successfully: "Run Archived Successfully",
  area_archive_successfully: "Zone Archived Successfully",
  zone: "Run",
  area: "Zone",
  archived_zone_list: "Archived Run",
  archived_state_list: "Archived State",
  error_in_archive: "Error In Archived Run",
  archived_area_list: "Archived Area",

  error_in_archive_area: "Error In Archived Zone",

  //Archive Zone Page

  zone_restore_successfully: "Run Restore Successfully",
  error_in_restore_zone: "Error In Restore Run",
  area_restore_successfully: "Zone Restore Successfully",
  error_in_restore_area: "Error In Restore Zone",

  // Archive Delivery List page

  error_in_archive_list: "Error in Archived List",
  delivery_address_restore_successfully: "Site location restored successfully",
  error_in_restore_delivery_address: "Error in restore site location",
  state_restore_successfully: "State Restore Successfully",
  error_in_restore_state: "Error In Restore State",
  subrub_restore_successfully: "Suburb Restore Successfully",
  error_in_restore_subrub: "Error In Restore Subrub",
  error_in_restore_street: "Error In Restore Street",
  street_restore_successfuly: "Street Restore Successfully",
  street_archived_successfully: "Street Archived Successfully",
  error_in_archive_street: "Error In Archived Street",
  pl_select_postal: "Select Postcode",
  pl_postal: "Postcode",
  pl_enter_select_postcode: "Select Postcode",
  //CompanyAddressList page
  error_in_company_adress_list: "Error in site location list",
  delivery_address_archive_successfully: "Site location archived successfully",

  error_in_archive_delivery_address: "Error in Archive Site Location",
  //Package

  pl_parcel_no: "Parcel No",
  pl_order_no: "Order No",
  val_parcel_no: "Please Enter Parcel No",
  pl_is_scanned: "Is Scanned",
  pl_is_picked_up: "Is Picked Up",
  pl_visited: "Visited",
  pl_departed: "Departed",
  pl_departed_latitude: "Departed Latitude",
  val_departed_latitude: "Please Enter Departed Latitude",
  pl_departed_longitude: "Departed Longitude",
  val_departed_longitude: "Please Enter Departed Longitude",
  pl_distance_to_next: "Distance To Next",
  val_distance_to_next: "Please Enter Distance To Next",
  pl_drive_time_to_next: "Drive Time To Next",
  val_drive_time_to_next: " Please Enter Drive Time To Next",
  pl_device_type: "Device Name",
  val_device_type: "Please Enter Device Name",
  pl_route_notes: "Route Notes",
  val_route_notes: "Please Enter Route Notes",
  pl_actual_arrival_time_computation: " Actual Arrival Time Computation",
  val_actual_arrival_time_computation:
    "Please Enter Actual Arrival Time Computation",
  error_in_restore_driver: "Error in restore driver",
  driver_restore_successfully: "Driver Restore Successfully",
  pl_actual_departure_time_computation: "Actual Departure Time Computation",
  val_emergency_contact_person_number_2: "Please Enter Valid Number",
  val_emergency_contact_person_name_2: "Please Enter Valid Name",
  val_actual_departure_time_computation:
    "Please Enter Actual Departure Time Computation",
  val_company_name_2: "Please Enter Valid Client Name",
  pl_actual_arrival_time: "Actual Arrival Time",
  val_actual_arrival_time: "Please Enter Actual Arrival Time",
  pl_vehicle_id: "Vehicle  Id",
  val_vehicle_id: "Please Enter Vehicle Id",
  pl_vehicle_alias: "Vehicle Alias",
  val_vehicle_alias: "Please Enter Vehicle Alias",
  pl_member_id: "Member Id",
  val_member_id: "Please Enter Member Id",
  pl_member_email: "Member Email",
  val_member_email: "Please Enter Member Email",
  pl_member_first_name: "Member First Name",
  val_member_first_name: "Please Enter Member First Name",
  pl_member_last_name: "Member Last Name",
  val_member_last_name: "Please Enter Member Last Name",
  pl_marked_arrival_time: "Marked Arrival Time",
  val_marked_arrival_time: "Please Enter Marked Arrival Time",
  pl_marked_departure_time: "Marked Departure Time",
  val_marked_departure_time: "Please Enter Marked Departure Time",
  pl_marked_stop_time: "Marked Stop Time",
  val_marked_stop_time: "Please Enter Marked Stop Time",
  //Requesteddemolist page
  pl_requested_demo_date_time: "Demo Request Date & Time",
  pl_requested_demo_date_time4: "Demo Date & Time",
  pl_note: "Note",
  place_note: "Add your notes here",
  error_in_requested_demo_list: "Error in Requested Demo List",
  status_updated_sucessfully: "Status Updated Successfully",
  requested_demo_archive_successfully: "Requested Demo Archived Successfully",
  error_in_archive_requested_demo: "Error in Archive Requested Demo",
  error_in_requested_demo_list_status_count:
    "Error in Requested Demo List Status Count",
  pl_requested_status_approached: "Status Approached",
  pl_requested_status_proposal: "Status Proposal",
  pl_requested_status_award: "Status Award",
  pl_requested_status_discard: "Status Discard",
  pl_enter_communication_detail: "Communication Detail",
  label_remark: "Enter Remark",
  pl_enter_remark: "Enter detail",
  label_document_upload: "Document Upload",
  val_document_upload: "Please upload document",
  status_changed_successfully: "Status Changed Successfully",
  error_in_changing_status: "Status not changed",
  val_remark: "Please enter remark",
  val_detail: "Please enter detail",
  label_upload_proposal: "Upload Proposal",
  //requesteddemo modal page

  error_in_updating_demo_list: "Error in Updating Demo List",
  demo_list_updated_successfully: "Demo List Updated Successfully",
  demo_list_updated_successfully1: "Demo Request Added Successfully",

  //requesteddemo filter modal page
  pl_requested_demo_filter: "Requested Demo Filter",
  pl_status: "Status",
  pl_select_status: "None",
  filter: "Filter",
  pl_max_date: "End Date",
  pl_min_date: "Start Date",

  //Roles List
  error_in_user_role: "Error in User Role",
  error_in_archive_user_role: "Error in Archive User Role",
  user_role_archive_successfully: "User Role Archive Successfully",
  error_in_restore_role: "Error in Restore User Role",
  role_restore_successfully: "User Role Restore Successfully",

  //adduserrole
  user_role_added_successfully: "User Role Added Succcessfully",
  user_role_updated_successfully: "User Role Updated Successfully",
  please_select_permission: "Please Select Permission",
  user_role_delete_successfully: "User Role Delete Successfully",
  error_in_delete_user_role: "Error in Delete User Role",

  //company documents List page
  eroor_in_company_document_list: "Error in Client Document List",
  company_document_archive_successfully: "Client Document Archive Successfully",

  //  ArchiveCompanyDocuments
  company_document_restore_successfully: "Client Document Restore Successfully",
  error_in_restore_company_document: "Error in Restore Client Document",

  //AddDocuments
  error_in_company_documents_list: "Error in Client Documents List",
  company_documents_added_successfully: "Client Documents Added Successfully",
  company_documents_updated_successfully:
    "Client Documents Updated Successfully",
  error_in_add_company_documents: "Error in add client documents",
  documents: "Documents",
  val_file: "Please Upload Document",

  //RFQ page
  pl_rfq: "RFQ",
  pl_add_rfq: "Add RFQ",
  rfq_history: " RFQ - History",
  po_summary: "Purchase Order Summary",
  label_estimated_price: "Estimated Price",
  val_estimated_price: "Please Added Estimated Price",
  pl_estimated_price: "Estimated Price",
  pl_rfq_history: "RFQ History",
  // po_summary: "Purchase Order Summary",
  val_amount_cap: "Please Enter Amount Cap",
  val_price_cap_timeline: "Please Enter Timeline Cap/ Price Validity (₹)",
  val_price_cap: "Please Enter Price Cap",
  pl_enter_price: "Please Enter Price",
  val_enter_price: "Enter Price",
  pl_enter_valid_price: "Please Enter Valid Price",
  est_label_code: "Estimated Price",
  est_pl_code: "Enter Estimated Price",

  // val_amount_cap: "Please Enter Amount Cap",
  val_timeline_cap: "Please Enter Timeline Cap/ Price Validity",

  archive_RFQ_history: "Archive RFQ History",
  rfq_history_restore_successfully: "RFQ Restored Successfully",
  error_in_archive_rfq_history: "Error in Archive RFQ History",
  error_in_restore_rfq_history: "Error in Restore RFQ History",
  rfq_archive_successfully: "RFQ Archive Successfully",
  rfq_history_archive_successfully: "RFQ Archived Successfully",
  error_in_rfq_history_archive: "Error in Archive RFQ History",
  error_in_rfq_history: "Error in RFQ History",
  error_in_archive_rfq: "Error in Archive RFQ",
  error_in_rfq_list: "Error in RFQ List",
  rfq_restore_successfully: "RFQ Restore Successfully",
  error_in_restore_rfq: "Error in Restore RFQ",
  pl_archive_rfq: "Archived RFQ",
  pl_transist_insurance: "Transist Insurance",
  pl_material_delivery_pincode: "Material Delivery Pincode",
  pl_price_cap: "Enter Price Cap (₹)",
  pl_timeline_cap: "Enter Timeline Cap/ Price Validity Cap (₹)",
  pl_quntity_cap: "Quantity Cap",
  add_rfq_succesfully: "RFQ Added Suceesfully",
  pr_assign_to_buyer_successfully: "PR Assign to Buyer Successfully",
  assign_pr: "Assign Purchase Requisition (PR)",
  float_rfq: "Float RFQ",
  //RFQ basic detail page
  pl_rfq_basic_detail: "RFQ Basic Detail",
  pl_amount_cap: "Enter Amount Cap (₹)",
  pl_search_rfq_number: "Search Repeat RFQ Number",
  rfq_approval_sent_successfully: "Rfq Sent For Approval",
  //Rfq detail
  pl_rfq_number: "RFQ Number",
  pl_currency: "Currency",
  pl_price_basis: "Price Basis",
  pl_select_price_basis: "Select Price Basis",
  pl_freight: "Freight",
  pl_select_freight: "Select Freight",
  pl_unloading: "Unloading",
  pl_transport_insurance: "Transport Insurance",
  error_in_rfq_detail: "Error in RFQ Detail",
  rfq_detail_added_successfully: "RFQ Detail Added Successfully",
  rfq_detail_updated_successfully: "RFQ Detail Updated Successfully",
  rfq_material_added_successfully: "RFQ Material Added Successfully",
  rfq_material_updated_successfully: "RFQ Material Updated Successfully",
  error_in_add_rfq_material: "Error in Add RFQ Material",

  pl_returnpackage: "Return Package",
  pl_returnPortal: "Return Portal",
  //Rfq Material
  pl_select_category: "Select Category",
  pl_material_name: "Material Name",
  pl_hsn: "HSN",
  val_hsn: "Please Enter HSN",
  pl_quantity: "Quantity",
  pl_enter_quantity: "Enter Quantity",
  pl_vendor: "Vendor",
  val_vendor: "Please Enter Vendor",
  val_material_name: "Please Enter Material Name",
  min_inquiry_value: "Please enter minimum inquiry value",
  max_inquiry_value: "Please enter maximum inquiry value",
  val_category: "Please Enter Category",
  val_quantity: "Please Enter Quantity",
  label_income_measurement: "Income Measurement",
  pl_income_measurement: "Select Income Measurement",
  val_income_measurement: "Enter valid Income Measurement",
  label_maximum_inquiry_value: "Maximum Inquiry Value",
  pl_maximum_inquiry_value: "Enter maximum inquiry value",
  val_maximum_inquiry_value: "Enter valid maximum inquiry value",
  //Bid Rfq
  error_in_bidding: "Error In Bidding",
  bidding_of_R0: "Bidding of R0 Successfully Done",
  bidding_of_R1: "Bidding of R1 Successfully Done",
  bidding_of_R: "Bidding of R Successfully Done",
  //RFQ document
  pl_documnet_name: "Document Name",

  //Material List Page
  material: "Material",
  materialMaster: "Material Master",
  pl_materialListing: "Material Listing",
  pl_material: "Material Master",
  pl_add_material: "Add Material",
  label_category_tree: "Category ",
  label_category: "Select Category",
  pl_category_tree: "Select category",
  val_category_tree: "Please select category",
  val_joining_date: "Please select Joining Date",
  label_short_description: "Short Description",
  label_erp_material: "ERP Material Code",
  pl_erp_material: "Enter ERP Material Code",
  val_erp_material: "Please Enter ERP Material Code",
  pl_short_description: "Enter Short Description",
  val_short_description: "Please enter short description",
  label_long_description: "Long Description",
  pl_long_description: "Enter Long Description",
  val_long_description: "Please enter long description",
  label_code: "Hey Courier Code",
  pl_code: "Enter Hey Courier Code",
  val_code: "Please enter code",
  label_unit_of_measurement: "UoM.",
  pl_unit_of_measurement: "Select UoM.",
  pl_unit_of_measurement_enter: "Enter Unit of Measurement",
  val_select_UoM: "Please Select UoM.",
  val_unit_of_measurement: "Please Enter Unit of Measurement",
  archive_unit_of_measurement: "Archived Unit Of Measurement",
  pl_add_unit_of_measurement: "Add UOM",
  label_image: "Image Upload",
  pl_image: "Choose Image",
  val_image: "Please Choose Image",
  upload_image: "Browse",
  error_in_archived_material: "Error In Archived Material List",
  archived_material: "Archived Material",
  material_updated_successfully: "Material updated successfully",
  material_added_successfully: "Material added successfully",
  archive: "Archive",
  error_in_list_material: "Error In List Material",
  material_archive_successfully: "Material Archive Successfully",
  material_archive_successfully6: "Material Archived Successfully",
  error_in_delete_material: "Error In Delete Material",
  purchase_requisition_added_successfully:
    "Purchase Requisition Added Successfully",
  purchase_requisition_updated_successfully:
    "Purchase Requisition Updated Successfully",
  purchase_requisition_draft_successfully:
    "Purchase Requisition Draft Successfully",
  purchase_requisition_draft_updated_successfully:
    "Purchase Requisition Draft Updated Successfully",

  //unit of measurement

  error_in_unit_of_measurement: "Error in UoM.",
  unit_of_measurement_archive_successfully: "UoM. Archived Successfully",
  unit_of_measurement_added_successfully: "UoM. added Successfully",
  unit_of_measurement_updated_successfully: "UoM. Updated successfully",
  unit_of_measurement_restore_successfully: "UoM. restored successfully",
  error_in_restore_unit_of_measurement: "Error in restored UoM.",

  //Subscription
  subscriptionMaster: "Subscription Master",
  subscriptionList: "Subscription Listing",
  error_in_subscription_list: "Error in subscription list",
  archived_subscription: "Archived Subscription",
  subscription_archive_successfully: "Subscription archived successfully",
  error_in_archive_subscription: "Error in archive subscription",
  error_in_archived_subscription_list: "Error in archived subscription list",
  subscription_restore_successfully: "Subscription restore successfully",
  error_in_restore_subscription: "Error in restore subscription",

  //Purchased Subscription
  error_in_purchased_subscription_list: "Error in purchased subscription list",
  purchasedSubscription: "Purchased Subscription",
  purchasedSubscriptionList: "Purchased Subscription Listing",
  archived_purchased_subscription: "Archived Purchased Subscription",
  label_payment_mode: "Payment Mode",
  pl_payment_mode: "Select Payment Mode",
  label_paymentRefId: "Payment RefID",
  pl_paymentRefId: "Select Payment RefID",
  val_subscription_type: "Please Enter Subscription Type",
  val_duration: "Please Enter Duration",
  val_per_user_price: "Please Enter Per User Price",
  val_payment_mode: "Please Enter Payment Mode",
  val_start_date: "Please Enter Start Date",
  val_end_date: "Please Enter End Date",
  pl_select_company: "Select Client",
  pl_select_subscription: "Select Subscription",
  pl_enter_duration: "Enter Duration",
  pl_enter_per_user_price: "Enter User Price (INR)",
  pl_zero_discount: "0",
  pl_enter_sell_price: "Enter Sell Price",
  pl_select_payment_mode: "Select Payment Mode",
  pl_start_date: "11-08-2023",
  pl_end_date: "11-09-2023",
  due_date: "Due Date",
  invoice_date: "Invoice Date",
  pl_due_date: "Due Date",
  pl_invoice_date: "Invoice Date",
  val_due_date: "Select Due Date",

  pl_select_company_type: "Select Type",
  val_invoice_date: "Select Invoice Date",
  val_sell_price: "Please Enter Sell Price",
  error_in_archived_purchase_subscription:
    "Error in Archived Purchase Subscription",
  purchased_subscription_restore_successfully:
    "Purchased Subscription Restore Successfully",
  error_in_restore_purchased_subscription:
    "Error in Restore Purchase Subscription",

  //Company Onboarding
  error_in_company_onboarding_list: "Error in client onboarding",
  company_onboarding_archive_successfully:
    "Client onboarding archive successfully",
  company_onboarding_archive_successfully1: "Client archived successfully",
  error_in_archive_company_onboarding: "Error in archive client onboarding",
  companyOnboarding: "Client Onboarding",
  addCompany: "Add Client",
  archived_company_onboarding: "Archived Client Onboarding",
  company_onboarding_restore_successfully:
    "Client onboarding restore successfully",
  company_onboarding_restore_successfully1: "Client restored successfully",
  error_in_restore_company_onboarding: "Error in restore client onboarding",
  addCompanyOnboarding: "Add Client Onboarding",
  label_company_name: "Client Name",
  pl_company_name: "Enter Client Name",
  pl_client_name: "Enter Company Name",
  val_company_name: "Please enter client name",
  label_person_name: "Person Name",
  pl_person_name: "Enter Person Name",
  val_person_name: "Please Enter Person Name",
  label_address_line_1: "Address Line 1",
  val_address_line_1: "Please enter address",
  val_WBS_number: "Please Enter WBS Number",
  image_aadhar_deleted_success: "Addharcard deleted successfully",
  image_pan_deleted_success: "Pancard deleted successfully",
  image_gst_deleted_success: "Gst document deleted successfully",
  payment_released_updated_successfully:
    "Payment released contact updated successfully",
  label_address_line_2: "Address Line 2",
  label_site_short_name: "Site Short Name",
  pl_site_short_name: "Enter site short name",
  val_site_short_name: "Please Enter Site Short Name",
  val_address_line_2: "Please Enter Address Line 2",
  val_pincode_select: "Please select valid pin code",
  label_no_of_employee: "No Of Employee",
  label_company_pan1: "Company PAN Number",
  pl_no_of_employee: "0 to 10",
  pl_back_to_list: "Back To List",
  val_no_of_employee: "Please enter no. of employee",
  label_assign_site_to_vendor: "Assign Site To Vendor",
  pl_assign_site_to_vendor: "select sites",
  val_assign_site_to_vendor: "Please select sites",
  label_cin_number: "CIN Number",

  pl_cin_number: "Please enter CIN number",

  val_cin_number: "Please enter valid CIN number",
  label_client_pan: "PAN Number",
  pl_client_pan: "Enter PAN number",
  label_company_pan: "PAN Number",
  pl_company_pan: "Enter PAN number",
  val_company_pan: "Enter PAN number",
  label_gst_no: "Please enter GST number",
  pl_gst_no: "Enter GST number",
  place_gst_no: "Enter GST number",
  place_gst_no5: "GST Number",
  val_gst_no: "Enter valid GST Number",
  val_about_company: "Please enter about client",
  keyperson: "Key Person",
  company_added_successfully: "Client Added Successfully",
  warehouse_added_successfully: "Warehouse Added Successfully",
  company_updated_successfully: "Client Updated Successfully",
  warehouse_updated_successfully: "Warehouse Updated Successfully",
  error_in_add_company: "Error in add client",
  please_enter_valid_phone: "Please enter valid phone",
  archived_company_document: "Archived Company Documents",
  error_in_restore_document: "Error in restore document",
  document_restore_successfully: "Document restore successfully",
  error_in_document_archive: "Error in document archive",
  document_archive_successfully: "Document archive successfully",

  //Pickup
  error_in_pickuppoint_list: "Error In Pickup Point List",
  pickuppoint_archive_successfully: "Pickup Point Archive Successfully",
  pickuppoint_restore_successfully: "Pickup Point Restore Successfully",
  error_in_restore_pickuppoint: "Error In Restore Pickup Point",
  error_in_archived_pickuppoint: "Error In Archived Pickup Point",
  pickuppoint_updated_successfully: "Pickup Point Updated Successfully",
  pickuppoint_added_successfully: "Pickup Point Added Successfully",

  //Depo Manager
  error_in_depomanager_list: "Error In Depo Manager List",
  depomanager_archive_successfully: "Depo Manager Archive Successfully",
  depomanager_restore_successfully: "Depo Manager Restore Successfully",
  error_in_restore_depomanager: "Error In Restore Depo Manager",
  error_in_archived_depomanager: "Error In Archived Depo Manager",
  depomanager_updated_successfully: "Depo Manager Updated Successfully",
  depomanager_added_successfully: "Depo Manager Added Successfully",

  //Vendor Onboarding
  vendor_communication_detail_updated:
    "Vendor Communication Detail Updated Successfully",
  vendor_communication_detail_added:
    "Vendor Communication Detail Added Successfully",
  vendorOnboarding: "Vendor Onboarding",
  addRFQBreadcrumb: "RFQ",
  pl_enter_vendor_code: "Enter vendor code",
  pl_vendor_code: "Vendor Code",
  addVendor: "Add Vendor",
  addVendorOnboarding: "Add Vendor Onboarding",
  verifyEmail:
    "RFQ - Verify Emails For Notifications at different stages(eg. Inquiry / Offer / Order)",
  verifyEmailBreadcrumb: "Verify Emails For Notifications",
  label_vendor_company_name: "Vendor Registered Name",
  rfq_email_person_name: "Person Name",
  pl_vendor_company_name: "Enter vendor Registered name",
  pl_email_person_name: "Enter Person Name",
  val_vendor_company_name: "Please enter vendor Registered name",
  error_in_vendor_onboarding_list: "Error in vendor onboarding list",
  label_account_holder_name: "Account Holder Name",
  pl_account_holder_name: "Enter Account Holder Name",
  val_account_holder_name: "Please enter account holder name",
  label_account_number: "Account Number",
  pl_account_number: "Enter Account Number",
  val_account_number: "Please Enter Account Number",
  label_bank_name: "Bank Name",
  pl_bank_name: "Enter Bank Name",
  val_bank_name: "Please Enter Bank Name",
  label_branch_name: "Branch Name",
  pl_branch_name: "Enter Branch Name",
  val_branch_name: "Please Enter Branch Name",
  label_ifsc_code: "IFSC / BSB Code",
  pl_ifsc_code: "Enter IFSC / BSB Code",
  delivery_rate_updated_successfully: "Delivery Rate Updated Successfully",
  delivery_rate_added_successfully: "Delivery Rate Added Successfully",
  val_ifsc_code: "Please Enter IFSC / BSB Code",
  vendor_onboarding_archive_successfully:
    "Vendor onboarding archive successfully",
  error_in_archive_vendor_onboarding: "Error in archive vendor onboarding",
  vendor_onboarding_restore_successfully:
    "Vendor onboarding restore successfully",
  error_in_restore_vendor_onboarding: "Error in restore vendor onboarding",
  archived_vendor_onboarding: "Archived Vendor Onboarding",
  vendor_added_successfully: "Vendor Added Successfully",
  please_enter_inquiry_value: "Please Enter Inquiry Value",
  vendor_updated_successfully: "Vendor Updated Successfully",
  document_added_successfully: "Document added successfully",
  document_updated_successfully: "Document updated successfully",
  archived_vendor_document: "Archived Vendor Document",
  error_in_adding_vendor: "Error in Adding Vendor",
  error_in_updating_vendor: "Error in Updating Vendor",
  bankDetails: "Bank Details",
  label_minimum_inquiry_value: "Minimum Inquiry Value",
  pl_minimum_inquiry_value: "Enter minimum inquiry value",
  value_minimum_inquiry_value: "Enter valid inquiry value",
  label_lut_number: "LUT Number",
  pl_lut_number: "Enter LUT number",
  val_lut_number: "Enter valid LUT Number",
  label_msme: "MSME",
  pl_msme_number: "MSME Number",
  pl_enter_msme_number: "UDYAM-XX-00-0000000",
  val_msme_number: "Enter valid msme number",
  pl_msme_document_upload: "MSME Document Upload",
  label_days_to_pay: "Days To Pay",
  pl_days_to_pay: "Select days to pay",
  pl_when_to_pay: "Select when to pay",
  pl_when_to_calculate: "Select when to calculate from",
  pl_advance: "Enter advance (%)",
  label_when_to_pay: "When To Pay",
  label_when_to_calculate: "From When To Calculate",
  label_advance: "Advance in %",
  pl_payment_security_type: "Select payment security type",
  val_payment_security_type: "Please Select Payment Security Type",
  pl_bank_garrentee_value: "Bank Guarantee Value",
  val_bank_garrentee_value: "Please enter valid value",
  pl_bank_guarantee_supply_limit_value: "Supply Limit Value",
  val_bank_guarantee_supply_limit_value: "Please enter valid limit",
  pl_bank_garrentee_open_date: "Open Date",
  pl_bank_garrentee_validity_complation_date: "Validity Complation Date",
  pl_lc_value: "LC Value",
  val_lc_value: "Please enter valid value",
  pl_lc_supply_limit_value: "Supply Limit Value",
  val_lc_supply_limit_value: "Please enter valid limit",
  pl_lc_open_date: "Open Date ",
  pl_lc_validity_complation_date: "Validity Complation Date",
  editCompanyOnboarding: "Edit Client Onboarding",
  editVendorOnboarding: "Edit Vendor Onboarding",
  payment_terms_updated_successfully: "Payment Term Updated Successfully",
  assignsite_added_successfully: "Assign Site Added Successfully",
  assignsite_updated_successfully: "Assign Site Updated Successfully",
  archived_assign_site: "Archived Assign Site",
  assign_site_archive_successfully: "Assign Site Archived Successfully",
  error_in_assign_site_archive: "Error in Assign Site Archive",
  assign_site_restore_successfully: "Assign Site Restore Successfully",
  error_in_restore_assign_site: "Error in Assign Site Restore",

  //PRApprovalHierarchy
  error_in_list_prapproval_hierarchy: "Error in pr approval hierarchy list",
  error_in_archive_prapproval_hierarchy:
    "Error in archive pr approval hierarchy",
  Error_in_site: "Error in Site",
  pr_approval_hierarchy_updated_successfully:
    "PR approval hierarchy updated successfully",
  pr_approval_hierarchy_added_successfully:
    "PR approval hierarchy added successfully",
  error_in_release_manager: "Error in release manager",
  error_in_prapproval_hierarchy: "Error in pr approval hierarchy",
  prapproval_hierarchy_archive_successfully:
    "PR approval hierarchy archive successfully",
  prapproval_hierarchy_restore_successfully:
    "PR approval hierarchy restore successfully",
  error_in_restore_prapproval_hierarchy:
    "Error in restore pr approval hierarchy",
  lbl_pr_release_hierarchy: "PR Release Hierarchy",

  please_enter_value_upto: "Please enter value",
  please_select_release_manager: "Please select release manager",
  bankdetail_updated_successfully: "Bank detail updated successully",
  keyperson_updated_successfully: "Keyperson updated successfully",
  inquiryvalue_updated_successfully: "Inquiry value updated successfully",
  //commercial invoice

  commercialInvoiceList: "Commercial Invoice List",
  addCommercialInvoice: "Add Commercial Invoice",

  //performa invoice

  performaInvoiceList: "Performa Invoice List",
  addPerformaInvoice: "Add Performa Invoice",
  val_invoice_number: "Please enter valid invoice number",
  label_invoice_number: "Invoice Number",
  pl_invoice_number: "Invoice Number",
  pl_billed_by: "Billed By",
  pl_billed_to: "Billed To",
  val_subscription_package: "Please enter valid subscription package",
  pl_HAWB: "HAWB",
  val_HAWB: "Please Enter HAWB Number",
  subscription_package: "Subscription Package",
  val_gst_number: "Please enter valid GST Number",
  pl_subscription_package: "Please enter subscription package",
  archived_category6: "Archived Category",
  pl_material_type4: "Material type",
  pl_archived_material_type_list6: "Archived Material Type",
  save_as_draft: "Save As Draft",
  val_note: "Please enter Note",
  pl_enter_amount: "Please enter amount",
  val_amount: "Please enter valid amount",
  pl_amount: "Amount",
  pl_enter_gst_number: " Enter GST number",
  pl_rate: "Rate",
  val_rate: "Please enter valid rate",
  pl_gst_number: "GST Number",
  // pl_note: "Note",
  pl_select_client: "Select Client",
  invoice_added_successfully: "Invoice Added Successfully",
  invoice_updated_successfully: "Invoice Updated Successfully",
  addInvoice: "Add Invoice",
  pl_select_caterory: "Select Caterory",
  pl_Customer_Code: "Customer Code",
  val_Customer_Code: "Please Enter Customer Code",
  pl_Customer_Name: "Customer Name",
  val_Customer_Name: "Please Enter Customer Name",
  pl_Customer_Address: "Customer Address",
  val_Customer_Address: "Please Enter Customer Address",
  pl_Postcode: "Postcode",
  pl_enter_postcode: "Enter Postcode",
  val_Postcode: "Please Enter Postcode",
  pl_Description_goods: "Description Goods",
  val_Description_goods: "Please Enter Description Goods",
  pl_special_instructions: "Special Instructions",
  val_special_instructions: "Please Enter Special Instructions",
  pl_delivery_instructions: "Delivery Instructions",
  val_delivery_instructions: "Please Enter Delivery Instructions",
  pl_Count: "Count",
  val_Count: "Please Enter Count",
  pl_piece_no: "Piece No.",
  val_piece_no: "Please Enter Piece No.",
  pl_total_pieces: "Total Pieces",
  val_total_pieces: "Please Enter Total Pieces",
  pl_Landed: "Landed",
  val_Landed: "Please Enter Landed",
  to_wight: "To Weight",
  pl_Weight: "Weight",
  to_weight: "To Weight",
  enter_weight: "Enter Weigth",
  price_by_weight: "Price by Weight",
  val_Weight: "Please Enter Weight",
  pl_enter_weight_end: "Enter To Weight",
  end_weight_unit_of_measuremen: "End Weight Unit of Measurement",
  pl_Shipper_Code: "Shipper Code",
  val_Shipper_Code: "Please Enter Shipper Code",
  pl_Shipper_Name: "Shipper Name",
  val_Shipper_Name: "Please Enter Shipper Name",
  pl_Shipper_Address: "Shipper Address",
  val_Shipper_Address: "Please Enter Shipper Address",
  pl_Shipper_City: "Shipper City",
  val_Shipper_City: "Please Enter Shipper City",
  pl_Shipper_State: "Shipper State",
  val_Shipper_State: "Please Enter Shipper State",
  pl_Shipper_Postcode: "Shipper Postcode",
  val_Shipper_Postcode: "Please Enter Shipper Postcode",
  pl_Shipper_Country: "Shipper Country",
  val_Shipper_Country: "Please Enter Shipper Country",
  pl_Origin: "Origin",
  val_Origin: "Please Enter Origin",
  pl_Port: "Port",
  val_Port: "Please Enter Port",
  pl_Total_Value: "Total Value",
  val_Total_Value: "Please Enter Total Value",
  pl_Goods_Currency: "Goods Currency",
  val_Goods_Currency: "Please Enter Goods Currency",
  pl_SAC: "SAC",
  val_SAC: "Please Enter SAC",
  pl_FR_Reference: "FR Reference",
  val_FR_Reference: "Please Enter FR Reference",
  pl_SubMaster: "SubMaster",
  val_SubMaster: "Please Enter SubMaster",
  pl_Pkg_Type: "Pkg Type",
  val_Pkg_Type: "Please Enter Pkg Type",
  pl_Country_Origin: "Country Origin",
  val_Country_Origin: "Please Enter Country Origin",
  pl_Cyber_Vendor_Account: "Cyber Vendor Account",
  val_Cyber_Vendor_Account: "Please Enter Cyber Vendor Account",
  pl_Customs_Code: "Customs Code",
  val_Customs_Code: "Please Enter Customs Code",
  pl_Cyber_Importer_Account: "Cyber Importer Account",
  val_Cyber_Importer_Account: "Please Enter Cyber Importer Account",
  pl_Importer_ABN: "Importer ABN",
  val_Importer_ABN: "Please Enter Importer ABN",
  pl_Importer_CAC: "Importer CAC",
  val_Importer_CAC: "Please Enter Importer CAC",
  pl_Cyber_Supplier_Account: "Cyber Supplier Account",
  val_Cyber_Supplier_Account: "Please Enter Cyber Supplier Account",
  pl_Supplier_Customs_Code: "Supplier Customs Code",
  val_Supplier_Customs_Code: "Please Enter Supplier Customs Code",
  pl_Companyonboardinglist: "Company Onboarding",

  label_contact_name: "Company Person Name",
  pl_contact_name: "Enter Person Name",
  // pl_company_name: "Enter Company Name",
  pl_company_client_name: "Enter Client Name",

  val_enter_contact_name: "Please Enter Company Person Name",
  label_abn_no: "ABN No.",
  label_invoice_payment_interval: "Invoice Payment Interval",
  pl_invoice_payment_interval: "Please enter the interval",
  val_invoice_payment_interval: "Please enter a valid interval",

  label_credit_limit: "Credit Limit",
  pl_credit_limit: "Please enter the limit",
  val_credit_limit: "Please enter a valid limit",

  label_note: "Note",
  // pl_note:" Enter Note",
  label_depo_address: "Depo Address",
  pl_depo_address: "Enter Depo Address",
  pl_abn_no: "Enter ABN No.",
  val_abn_no_2: "Please Enter ABN No.",
  val_note_2: "Please Enter Note",
  //confirmmessage
  label_Address: "Flat, House no., Building",
  label_area: "Area, Street, Sector, Village",
  pl_sub_category_example: "Example General Cement, Special Cement, RMC",

  label_landmark: "Landmark",
  lbl_city: "Town/City",
  confirmAlert_title: "Confirm to update status ?",
  confirmAlert_assigned_driver_title: "Confirm to assign driver ?",
  confirmAlert_assigned_driver_message: "Are you sure to assign this ?",
  confirmAlert_message: "Are you sure to do this ?",
  confirmAlert_ok: "Yes",
  confirmAlert_cancel: "Cancel",
  pl_contact_person_name: "Contact Person Name",
  val_contact_person_name: "Please Enter Contact Person Name",
  pl_enter_contact_person_name: "Enter Contact Person Name",
  place_enter_contact_person_name: "Enter contact person name",

  //MaterialTypeList page
  error_in_material_type: "Error in Material Type",
  material_type_archive_successfully: "Material type archive successfully",
  material_type_archive_successfully6: "Material type archived successfully",
  pl_material_type: "Select material type",
  // pl_material_type4: "Material type",

  pl_add_material_type: "Add Material Type",
  pl_select_material_type: "Select Material Type",
  pl_enter_valid_date: "Enter valid date",
  pl_hsn_code: "HSN CODE",
  pl_enter_hsn_code: "Enter HSN Code",
  val_hsn_code: "Please enter valid HSN code",
  error_in_add_material_code: "Error in material code",
  material_code_updated_successfully: "Material Code Updated Successfully",
  material_code_added_successfully: "Material Code Added Successfully",
  //Archived Material Type List page
  pl_archived_material_list: "archived material list",
  pl_archived_material_type_list: "Archived material type",
  material_type_restore_successfully: "Material type restore successfully",
  error_in_restore_material_type: "Error in restore material type",
  error_in_company_list: "Error in company list",
  error_in_warehouse_list: "Error in Warehouse list",
  //Add MaterialTypeList page
  pl_enter_type: "Enter material type",
  error_in_adding_material_type: "Error in adding material type",
  error_in_updating_material_type: "Error in updating material type",
  material_type_added_successfully: "Material type added successfully",
  material_type_updated_successfully: "Material type updated successfully",
  error_in_add_material: "Error in add material",
  material_restore_successfully: "Material restore successfully",
  material_restore_successfully6: "Material restored successfully",
  error_in_restore_material: "Error in restore material",
  label_gst: "GST (%)",
  pl_gst: "Enter GST",
  label_estimated_unit_price: "Estimated Unit Price",
  pl_estimated_unit_price: "Enter unit price",
  val_estimated_unit_price: "Enter valid unit price",
  label_escalation: "Escalation (%)",
  pl_escalation: "Enter escalation",
  val_escalation: "Enter valid escalation",
  pl_sub_category: "Sub Category",
  val_sub_category: "Please enter sub category",
  val_category_wise_WBS_number: "Please Enter WBS Number",
  pl_gst5: "Please enter GST",

  // PlaceHolders / Lables

  pl_company: "Client",
  company_name_requesteddemo: "Company",
  pl_demo_date: "Demo Date",
  pl_demo_date_time: "Demo Date & Time",
  pl_companyName: "Company Name",
  pl_typeCompanyName: "Company Name Type Here",
  pl_mfg_facility_location: "Mfg. Facility Location",
  place_personName: "Enter Person Name",
  pl_personName: "Person Name",
  pl_personName1: "Enter Person Name",
  pl_name: "Client Personnel",
  pl_requested_name: "Name",
  pl_designation_name: "Functional Designation",
  pl_phone: "Phone",
  pl_ContactNo: "Contact Number",
  pl_designation: "Enter designation",
  pl_designation1: "Enter Designation",
  lbb_designation: "Designation",
  place_designation: "Enter your designation",
  pl_password: "Password",
  pl_current_password: "Current Password",
  pl_newpassword: "New Password",
  pl_confirm_password: "Confirm Password",
  pl_email: "Enter email",
  lbb_email: "Email",

  // lbb_email: "Enter Email",
  place_email: "Enter your email",
  pl_email1: "Enter your registered email",
  pl_personalEmail: "Official Email",
  pl_personMobile: "Contact / Mobile Number",
  pl_msg: "Message",
  pl_country: "Country",
  pl_chooseCountry: "Choose Country",
  pl_state: "State",
  place_state: "Select Your State",
  pl_enter_state: "Enter State",
  val_enter_state: "Please Enter State",
  // pl_city: "City",
  pl_street: "Street",
  // pl_suburb: "Suburb",
  pl_add_suburb: "Add Suburb",
  place_city: "Select your city",
  pl_landmark: "Landmark",
  pl_website: "Website",
  place_website: "Enter your website",
  pl_corporateAddress: "Corporate Address",
  pl_addressLine1: "Address Line 1",
  pl_addressLine2: "Address Line 2",
  pl_headOffice_email: "Head Office Email",
  pl_headOffice_contactNo: "Head Office Contact Number",
  pl_company_RegistrationNo: "Company Registration No",
  pl_company_establishedDate: "Company Establishment date",
  pl_gstNo: "GSTN",
  pl_manufacturing_fromCountry: "Manufacturing from country",
  pl_supplying_toCountries: "Supplying to Countries",
  pl_how_did_you_hear_about_us: "How did you hear about us",
  pl_facility_email: "Facility Email",
  pl_facility_contact_number: "Facility Contact Number",
  pl_address_line_1: "Enter your address",
  pl_address_line_2: "Enter your address",
  upload_fileType: "(.jpg,.png,.pdf,.ppt,.docx)",
  upload_imagefileType: "(.jpg, .png)",

  pl_no_of_manufacturing_facilities: "No. Of Manufacturing Facilities",
  pl_manufacturing_country: "Manufacturing From Country",
  pl_supplying_country: "Supplying To Countries",
  pl_video_url: "Video Link Url",
  pl_about_company: "About Client",
  place_about_company: "Enter about client",
  pl_about_vendor: "About Vendor",
  pl_other_payment_type: "Other Payment Security Type",
  pl_enter_payment_type: "Enter Other Payment Type",
  pl_enter_about_vendor: "Enter About Vendor",
  val_about_vendor: "Please Enter About Vendor",
  pl_about_me: "About Me",
  pl_user_name: "User Name",
  pl_first_name: "First Name",
  pl_last_name: "Last Name",
  pl_search: "search",
  pl_facility_location: "Facality Location",

  pl_company_email: "Company Email",
  pl_user_role: "User Role",
  pl_message: "Message",
  pl_reply_to: "Reply To",
  pl_reason_contacting_support_lable: "Reason For Contacting Support",
  pl_reason_contacting_support: "Why Are You Contacting Support?",
  pl_how_help: "How Can We Help You",

  label_package_name: "Package Name",
  val_package_name: "Please Enter Package Name",
  pl_subscription_type: "Subscription Type",
  pl_per_user_price: "Per User Price (INR)",
  pl_purchase_requistions: "Purchase Requistions",
  pl_label_start_date: "Start Date",
  pl_label_end_date: "End Date",

  pl_concierge_type: "Concierge Type",
  pl_package_type: "Package Type",
  pl_actual_price: "Actual Price (INR)",
  pl_discount: "Discount (%)",
  pl_sell_price: "Sell Price (INR)",
  pl_duration: "Duration (days)",
  pl_description_subscription: "Description",

  pl_login_with_email: "youremail@gmail.com",
  pl_login_with_mobile: "+91 Mobile Number",
  pl_get_otp: "Get OTP",
  didnotreceived: "Didn't Received?",

  // ForgotPassword
  pl_forgot_password_label1:
    "Enter your registered email address and we will send you a link to reset your password",
  pl_enter_email_or_mobile_number: "Enter Email OR Mobile Number",

  //ResetPassword
  pl_new_password_label1:
    "Your new password must be different from previously used password",
  pl_enter_new_password: "Enter new password",
  pl_confirm_your_password: "Confirm your password",
  pl_reset_password: "Reset Password",
  val_select_role: "Please Add A Role And Permission",
  pop_title_qr: "Are you sure you want to download QR?",
  pop_title_print: "Are you sure you want to print labels?",
  pl_log_out_pop_up_msg: "Are you sure you want to log out?",
  pop_title_assign_zone: "Are you sure to assign the zone?",
  pop_title_assigned_to: "Are you sure to assign the driver?",
  pop_title_password: "Are you sure to change the password?",
  pop_title_api_key: "Please confirm to send the API key to company email?",
  pop_pickup_point_status_message:
    "Are You Sure You Want To Change Pickup Point Status ?",
  pop_depomanager_status_message:
    "Are You Sure You Want To Change Depo Manager Status ?",
  //RequestedDemoList
  pl_requested_demo: "Demo Request",
  pl_enter_your_name: "Enter your name",
  pl_enter_your_designation: "Enter Your Designation",
  pl_enter_your_company_name: "Enter your company name",
  pl_mobile_number: "Mobile Number",
  pl_enter_your_mobile_number: "Enter your mobile number",
  pl_e_mail: "Email",
  pl_enter_your_email: "Enter your email",
  pl_number_of_buyers: "Buyer Count",
  pl_num_of_buyers: "Number Of Buyer",
  pl_upload_gst: "Upload GST Document",
  pl_enter_number_of_buyers: "Enter number of buyers",
  pl_enter_about_your_company: "Enter about your company",
  pl_enter_your_message: "Enter Your Message",
  pl_active: "Active",
  pl_save_changes: "Save Changes",
  pl_remark: "Remark",
  place_remark: "Your remarks or suggestions",
  pl_enter_about_your_company_profile: "Enter client profile",
  pl_about_company_profile: "Client Profile",
  pl_about_company_requesteddemo: "About Company",
  pl_enter_about_your_company_requesteddemo: "Enter about your company",
  //Add Driver
  pl_select_company_onboarding: "Select Company",
  val_company_onboarding: "Please Select Company",
  pl_company_onboarding: "Company",
  label_weight_start: "Start Weight",
  pl_weight_start: "Enter Start Weight",
  val_weight_start: "Please Enter Start Weight",
  val_weight_from: "Please Enter From Weight",
  label_weight_end: "End Weight",
  pl_weight_end: "Enter End Weight",
  val_weight_end: "Please Enter End Weight",
  val_uom: "Please Enter Unit of Measurement",
  pl_uom: "Unit OF Measurement",
  pl_select_uom: "Select Unit Of Measurement",
  val_currency: "Please Enter Currency",
  // pl_currency:"Currency",
  label_currency: "Currency",
  // val_rate:"Please Enter Rate",
  // pl_rate:"Enter Rate",
  label_rate: "Rate",
  from_weight: "From Weight",
  delivery_status: "Delivery Status",
  pl_delivery_status: "Select Delivery Status",
  pl_start_min_date: "Enter Start Date",
  statr_date: "Start Date",
  end_date: "End Date",
  pl_end_max_date: "Enter End Date",
  pl_Weight_start: "Start Weight",
  pl_Weight_end: "End Weight",
  start_weight_unit_of_measurement: "Start Weight Unit Of Mesurement",
  pl_enter_weight_start: "Enter Weight Start",
  pl_enter_from_weight: "Enter From Weight",
  //Setting page
  pl_shipping_address: "Shipping Address",
  pl_billing_address: "Billing Address",
  pl_select_currency: "Select Currency",
  error_in_settings: "Error in settings",
  settings_updated_successfully: "Settings updated successfully",
  error_in_business_setting: "Error in business setting",
  business_setting_added_successfully: "Business setting added successfully",
  business_setting_updated_successfully:
    "Business setting updated successfully",
  pl_rfq_second_value_up_to: "Please enter value",
  pl_select_rfq_second_release_manager:
    "Please select rfq second release manager",
  pl_rfq_third_value_up_to: "Please enter value",
  pl_select_rfq_third_release_manager:
    "Please select rfq third release manager",
  pl_rfq_forth_value_up_to: "Please enter value",
  pl_select_rfq_forth_release_manager:
    "Please select rfq forth release manager",
  pl_rfq_fifth_value_up_to: "Please enter value",
  pl_select_rfq_fifth_release_manager:
    "Please select rfq fifth release manager",
  pl_approval_second_value_up_to: "Please enter value",
  pl_select_approval_second_release_manager:
    "Please select approval second release manager",
  pl_approval_third_value_up_to: "Please enter value",
  pl_select_approval_third_release_manager:
    "Please select approval third release manager",
  pl_approval_forth_value_up_to: "Please enter value",
  pl_select_approval_forth_release_manager:
    "Please select approval forth release manager",
  pl_approval_fifth_value_up_to: "Please enter value",
  pl_select_approval_fifth_release_manager:
    "Please select approval fifth release manager",
  pl_purchase_order_second_value_up_to: "Please enter value",
  pl_select_purchase_order_second_release_manager:
    "Please select po second release manager",
  pl_purchase_order_third_value_up_to: "Please enter value",
  pl_select_purchase_order_third_release_manager:
    "Please select po third release manager",
  pl_purchase_order_forth_value_up_to: "Please enter value",
  pl_select_purchase_order_forth_release_manager:
    "Please select po forth release manager",
  pl_purchase_order_fifth_value_up_to: "Please enter value",
  pl_select_purchase_order_fifth_release_manager:
    "Please select po fifth release manager",

  //Add Employee
  label_employeeId: "Employee ID",
  pl_employeeId: "Enter Your Id",
  val_employeeId: "Please Enter Your Employee ID",
  label_firstName: "First Name",
  pl_firstName: "Enter Your First Name",
  label_lastName: "Last Name",
  pl_lastName: "Enter Your Last Name",
  label_email: "Email",
  pl_email_2: "Enter Employee's Email",
  pl_company_email_2: "Enter Company Email",
  val_address_2: "Please Enter Valid Address",
  add_employee: "Add Employee",
  label_mobileNumber: "Mobile Number",
  label_phoneNumber: "Contact Number",
  label_phoneNumber_customer: "Customer Number",
  label_company_number: "Company Person Number",
  search_company_address: "Search Company Address",
  // label_depo_address: "Depo Address",
  search_depo_address: "Search Depo Address",
  pl_enter_additional_detail: "Please Enter Additional Detail",
  enter_additional_details: "Enter Additional Details",
  additional_details: "Additional Details",
  pl_contact_num: "Enter Your Contact Number",
  pl_contact_num_customer: "Enter Your Customer Number",
  label_company_address: "Company Address",
  label_street_address: "Street Address",
  pl_company_contact: "Enter Person Number",
  val_mobileNumber: "Please enter valid mobile number",
  val_contact_num: "Please Enter Valid Contact Number",
  val_contact_num_customer: "Please Enter Valid Customer Number",
  val_company_contact: "Please Enter Valid Company Contact Number",
  // company_added_successfully: "Company Added Successfully",
  // company_updated_successfully: "Company Updated Successfully",
  error_in_adding_company: "Error In Adding Comapny",
  error_in_updating_company: "Error In Updating Company",
  company_restore_successfully: "Company Restore Successfully",
  warehouse_restore_successfully: "Warehouse Restore Successfully",
  error_in_restore_company: "Error In Restore Company",
  error_in_restore_warehouse: "Error In Restore Warehouse",
  company_archive_successfully: "Company Archive Successfully",
  warehouse_archive_successfully: "Warehouse Archive Successfully",

  pl_mobileNumber: "Enter Your Mobile Number",
  // val_mobileNumber: "Please enter valid mobile number",
  label_designation: "Designation",
  label_resignation: "Resignation Date",
  label_reliving: "Reliving Date",
  pl_designation_2: "Enter Your Designation",
  pl_emergency_contact: "Enter Emergency Contact Number",
  pl_resignation: "Enter Resignation Date",
  pl_reliving: "Enter Reliving Date",
  val_designation_2: "Please Enter Valid Designation",
  label_role: "Select Work On",
  pl_role: "Enter Number Of Buyer",
  val_role: "Please Select Valid Number Of Buyer",
  pl_site_name_select: "Select Site Name",
  label_adharcard: "Aadhar Number",
  pl_adharcard: "987487454784",
  val_adharcard: "Please enter valid aadhar number",
  label_pancard: "PAN Number",
  pl_pancard: "EYYOP4012K",
  val_pancard: "Please enter valid PAN number",
  label_emergencyContact: "Emergency Contact",
  pl_emergencyContact: "Enter Number",
  val_emergencyContact: "Please enter valid number",
  label_currentAddress: "Current Address",
  pl_address: "Enter your address",
  val_address: "Please enter valid address",
  label_permanentAddress: "Permanent Address",
  label_status: "Status",
  // pl_select_status:"Select Status",
  val_status: "Please choose valid status",

  pl_employee: "Employee",
  employee_added_successfully: "Employee Added Successfully",
  employee_updated_successfully: "Employee Updated Successfully",
  error_in_list_employee: "Error In List Employee",
  employee_restore_successfully: "Employee Restore Successfully",
  error_in_restore_employee: "Error In Restore Employee",
  employee_archive_successfully: "Employee Archive Successfully",
  error_in_delete_employee: "Error In Delete Employee",
  label_pr_value_limit: "PR Value Limit (₹)",
  pl_pr_value_limit: "Enter PR value limit",
  val_pr_value_limit: "Please enter PR value limit",
  //Pincode
  pl_pincode: "Pin Code",
  pl_pincodeselect: "Select Pin Code",
  pl_enter_pincode: "Enter Pin Code",
  pl_zone: "Run",
  pl_area: "Zone",
  val_zone: "Select Run",
  val_area: "Select Zone",
  pl_edit_zone: "Edit Run",
  pl_edit_area: "Edit Zone",
  pl_select_zone: "Select Run",
  pl_select_area: "Select Zone",
  pl_select_country: "Select Country",
  pl_select_state: "Select State",
  // pl_select_city: "Select City"
  pl_select_suburb: "Select Suburb",
  pincode_archive_successfully: "Pin Code Archived Successfully",
  error_in_delete_pincode: "Error In Delete Pin Code",
  pincode_added_successfully: "Pin Code Added Successfully",
  pincode_updated_successfully: "Pin Code Updated Successfully",
  error_in_adding_pincode: "Error In Adding Pin Code",
  error_in_updating_pincode: "Error In Updating Pin Code",
  pincode_restore_successfully: "Pin Code Restore Successfully",
  error_in_restore_pincode: "Error In Restored Pin Code",
  sample_file: "Sample File",

  follow_up_added_successfully: "Follow Up Date Added",
  follow_up_updated_successfully: "Follow Up Date Updated",

  //login Page
  pl_email_or_mobile: "Email or Mobile",
  pl_enter_your_email_or_mobile_email: "Enter your registered email or mobile",
  pl_enter_your_password: "Please enter your password",
  pl_forgot_password: "Forgot Password ?",

  // AddZoneModel page
  pl_zone_name: "Run Name",
  pl_area_name: "Zone Name",
  pl_state_name: "State",
  pl_archive: "Archive",
  pl_search_list: "Search List",
  pl_add_zone: "Add Run",
  pl_add_area: "Add Zone",
  pl_enter_zone: "Enter Run",
  pl_enter_area: "Enter Zone",
  msg_pleaseUploadFile: "Please Upload File",
  pl_archive1: "Archived",
  // pl_state: "State",
  val_select_suburb: "Please Selece Suburb",
  val_state_name: "Enter Valid State",
  val_select_state: "Please Select State",
  val_select_city: "Please Select City",
  val_enter_pincode: "Enter Valid Pin Code",
  package_type_updated_successfully2: "Package Type Updated Successfully",
  package_type_added_successfully2: "Package Type Added Successfully",
  //AddStateModel Page
  pl_add_state: "Add State",
  pl_edit_state: "Edit State",
  // pl_enter_state: "Enter State",
  pl_enter_valid_state_name: "Please Enter Valid State Name",
  company: "Company",
  // pl_select_company:"Select Company",
  val_select_company: "Please Select Company",
  //City
  city_added_successfully: "City Added Successfully",
  city_updated_successfully: "City Updated Successfully",
  //Employee List
  employeeList: "Employee",
  error_in_employee_list: "Error in employee list",
  pl_employeeListing: "Employee List",
  pl_add_employee: "Add Employee",
  error_in_updating_employee: "Error in updating employee",
  error_in_adding_employee: "Error in adding employee",
  error_in_updating_driver: "Error in updating driver",
  error_in_adding_driver: "Error in adding driver",
  pending: "Pending",
  active: "Active",
  inactive: "Inactive",
  archived_employee_list: "Archived Employee List",
  // Requested demo list page
  pl_add_request_demo: " Add Request Demo",
  pl_demo_requested: "Demo Request Cockpit",
  pl_demo_request: "Demo Request",

  //Archive list page

  pl_Archive: " Archive",
  pl_archived_demo_request: "Archived Demo Request",
  pl_restore: "Restore",
  requested_demo_restore_successfully: "Requested Demo Restore Successfully",
  error_in_restore_requested_demo: "Error in Restore Requested Demo List",

  //AddAddress page
  error_in_list_delivery_address: "Error in list of site location",
  delivery_address_added_successfully: "Site location added successfully",
  delivery_address_updated_successfully: "Site location updated successfully",
  pl_delivery_charge: "Delivery Charge",
  val_delivery_charge: "Please enter Delivery Charge",
  pl_site_location: "Site Location",
  pl_date: "Date",
  pl_site_location_list: "Site Location List",
  pl_add_address: "Add Site Location",
  pl_address_label: "Address Master",
  pl_enter_company_name: "Enter company legal name",
  val_select_company_name: "Please enter company name",
  pl_enter_site: "Enter site name",
  pl_address1: "Address",
  val_site: "Please Enter Site Name",
  pl_state_province: "State/Province",
  pl_postal_zip_code: "Postal / Zip Code",
  pl_land_mark: "Land Mark",
  place_land_mark: "Enter landmark",
  place_landmark: "Enter landmark",
  pl_street_address_line_1: "Street Address Line 1",
  street_address: "Street Address",
  var_street_address: "Search Street Address",
  pl_street_address: "Enter Street Address",
  pl_phone_or_whatsapp_number: "Phone or WhatsApp Number",
  // pl_phone: "Contact Number",
  pl_phone_alternate: "Alternate Contact Number",
  pl_emailname: "Email",
  pl_enter_email: "Enter Email",
  place_enter_email: "Enter email",
  pl_address_type: "Address Type",
  pl_DeliveryStatus: "Delivery Status",
  val_DeliveryStatus: "Select Delivery Status",
  // PurchaseReuisition
  pl_purchase_requisition: "Purchase Requisition",
  pl_purchase_requisition_list: "Purchase Requisition List",
  pl_add_purchase_requisition: "Add Purchase Requisition",
  enter_quantity: "Enter Quantity",
  enter_amount: "Enter Amount",
  label_site: "Site",
  val_site_name: "Please Enter Site Name",
  archived_purchase_requisition: "Archived Purchase Requisition (PR)",

  val_parcel_no_invalid: "Please Enter Number",

  // Activity Log page
  pl_activity_log: "Activity Log",
  pl_archive_activity_log: "Archived Activity Log",
  error_in_activity_log_list: "Error in Activity Log List",
  activity_log_archive_successfully: "Activity Log Archive Successfully",
  error_in_archive_activity_log: "Error in Archive Activity Log",
  activity_log_restore_successfully: "Activity Log Restore Successfully",
  error_in_restore_activity_log: "Error in Restore Activity Log",

  //Hierarchy page
  label_hierarchy: "Enter Hierarchy Name",
  pl_rfq_approval: "RFQ Approval",
  pl_applicable_on: "Applicable On",
  pl_select_employee: "Select Employee",
  val_select_employee: "Please Select Employee",
  purchase_requisition_delete_successfully:
    "Purchase Requisition Deleted Successfully",
  pop_delete_title: "Are you sure you want to delete permanently ?",
  email_notified: "Email notified",
  error_in_delete_purchase_requisition_history:
    "Error in Deleting Purchase Requisition",
  val_sequence: "Please Enter Sequence",
  pl_sequence: "Sequence",
  pl_hierarchy: "Hierarchy",
  pl_adddeliveryrate: "Add Delivery Rate",

  pl_price: "Price",
  val_price: "Select Price",
  pl_Currcy: "Currency",
  // val_currency:"Enter Currency",
  //ArchiveDelivery List
  pl_archive_delivery: "Archived Site Location",

  //company documents
  pl_company_documents: " Client Documents",
  pl_add_documents: "Add Documents",

  //ArchiveCompanyDocuments
  pl_archive_company_documents: "Archived Client Documents",

  //Add Documents
  pl_document_name: "Document Name",
  place_upload_document: "Upload Document",
  pl_enter_document_name: "Enter Document Name",
  pl_upload_document: "Upload Document",
  pl_upload_aadhar: "Upload Aadhar Document",
  pl_upload_pan: "Upload PAN Document",
  pl_choose_document: "Choose Document",
  //Roles List
  pl_roles: "Role",
  pl_role_listing: "Role List",
  pl_add_role: "Add Role",

  // AddRole
  pl_permission: "Permission",

  //AddNewPurchaseRequesitition
  favourite_added_successfully: "Favourite Added Successfully",
  favourite_updated_successfully: "Favourite Updated Successfully",

  error_in_purchase_requisition: "Error in Purchase Requisition",

  purchase_requisition_history_restore_successfully:
    "Purchase Requisition Restore Successfully",
  error_in_restore_purchase_requisition_history:
    "Error in Restore Purchase Requisition History",

  purchase_requisition_history_archive_successfully:
    "Purchase Requisition History Archive Successfully",
  package_updated_successfully: "Package Updated Successfully",
  package_added_successfully: "Package Added Successfully",
  // Value msg
  name: "Name",
  pl_driver_name: "Enter Name",
  val_name: "Please Enter Name",
  val_designation1: "Please Enter Correct Designation",
  val__name: "Please Enter Valid Name",
  val_personName: "Please Enter Person Name",
  val_companyName: "Please Enter Client Name",
  val_phone: "Please Enter Valid Phone",
  val_phone1: "Please Enter Valid Registered Phone Number",
  val_city: "Please Enter City",
  val_city1: "Please Select City",
  val_street: "Please Select Street",
  val_landmark: "Please Enter Landmark",
  pop_delete: "Are You Sure To Delete ?",
  pop_title: "Are You Sure To Archive ?",
  // pop_delete: "Are You Sure To Delete ?",
  pop_title_assign_driver: "Are you sure to assign the driver?",
  pop_title_optimize_route: "Are you sure to optimize the route?",
  pop_restore_title: "Are You Sure To Restore ?",
  pop_photoTitle: "Are you sure archive this image ?",
  val_emergency_contact: "Please enter emergency contact number",
  val_designation: "Please enter designation",
  val_password: "Please enter password",
  val_confirm_password: "Please enter confirm password",
  val_email: "Please Enter Valid Email",
  val_email1: "Please enter valid registered email!",
  pl_read_term_and_condition: "Please Read Terms and Conditions",
  val_terms_and_conditions: "Please Accept Terms and Conditions",
  val_registrationNo: "Please enter valid registration no!",
  val_mfg_facility_location: "Please enter mfg. facility location",
  val_facility_location: "Please select facility location",
  val_msg: "Please enter message",
  val_company: "Please select client",
  val_country: "Please Select Country",
  val_state: "Please Enter State",
  pl_create_optimize_route: "Create Optimize Route",
  // val_city: "Please enter city",
  // val_landmark: "Please enter landmark",
  val_pincode: "Please Enter Valid Pin Code",
  val_website: "Please Enter Valid URL",
  val_corporateAddress: "Please Enter Corporate Address",
  val_addressLine: "Please Enter Valid Address",
  val_addressLine1: "Please Enter Address Line 1",
  val_addressLine2: "Address Line 2",
  val_gstNo: "Please Enter Valid GST Number",
  val_company_RegistrationNo: "Please Enter Client Registration No",
  val_no_of_manufacturing_facilities:
    "Please Enter No. of Manufacturing Facilities",
  val_manufacturing_country: "Please Select Manufacturing From Country",
  val_supplying_country: "Please select supplying to Countries",
  val_video_url: "Please enter valid url",
  val_number: "Please enter valid number",
  val_about_me: "Please enter about me",

  val_reply_to: "Please enter reply to",
  val_how_help: "Please describe your question or issue in detail",
  val_reason_contacting_support: "Please enter reason for contacting support",
  val_user_role: "Please Select User Role",
  val_document_name: "Please Enter Document Name",
  val_zone_name: "Plase Enter Valid Run Name",
  val_area_name: "Plase Enter Valid Zone Name",
  val_description: "Please Enter Description",
  val_material_type: "Please Enter Material ype",
  // val_sub_category: "Please enter sub category",

  // val_escalation: "Please enter escalation",

  val_select_material_type: "Please select material type",

  //Login Page
  val_enter_email_or_mobile: "Enter Email or Mobile",
  val_please_enter_your_password: "Please Enter your Password",

  //AddAddress
  val_please_enter_address: "Please Enter Street Address",
  enter_street: "Enter Street",
  // pl_date:"Select Date",
  pl_package_delivery_date: "Package Delivery Date",
  pl_select_date: "Please Select Date",
  pl_enter_street: "Please Enter Street",
  val_address1: "Please Enter Address Line 1",
  val_state_province: "Please Enter State/Province",
  val_state1: "Please Select State",
  val_postal_zip_code: "Please Enter Postal/Zip Code",
  val_postal_zip_code1: "Please Enter Postal/Zip Code",
  val_postal_open_date: "Please Select Open Date",
  val_postal_validity_complation: "Please Select Validity Complation Date",
  val_please_enter_land_mark: "Please Enter Land Mark",
  val_address_type: "Please Enter Address Type",

  assign_pr_archive_successfully: "Assign PR Archive Successfully",
  error_in_archive_assign_pr: "Error in Archive Assign PR",
  pl_archive_float_rfq: "Archive Assign Purchase Requisition",
  assign_purchase_requisition_restore_successfully:
    "Assign Purchase Requisition Restore Successfully",
  error_in_restore_assign_purchase_requisition:
    "Error in Restore Assign Purchase Requisition",
  error_in_archive_assign_purchase_requisition:
    "Error in Archive Assign Purchase Requisition",
  sector_name_added_successfully: "Sector name added successfully",
  sector_name_updated_successfully: "Sector name updated successfully",
  error_in_adding_sector_name: "Error in adding sector name",
  error_in_updating_sector_name: "Error in updating sector name",

  place_material_type: "Material Type",
  label_place_remark: "Remark",
  pl_enter_communication_remark: "Enter communication detail",
  // pl_enter_remark: "Enter detail",

  // Sector Page
  sector_name: "Sector Name",
  enter_sector_name: "Enter sector name",
  pl_enter_sector_name: "Please enter sector name",
  pl_search_document: "Search document",
  sector: "Sector",
  pl_add_sector: "Add Sector",
  sector_archive_successfully: "Sector name archive successfully",
  sector_archive_successfully1: "Sector archived successfully",
  error_in_archive_sector_name: "Error in archive sector name",
  error_in_sector_name: "Error in sector name",
  sector_restore_successfully: "Sector name restore successfully",
  sector_restore_successfully2: "Sector restored successfully",
  error_in_restore_sector: "Error in restore sector name",
  archived_sector_list: "Archived sectors",
  //requesteddemo list page
  val_number_of_buyers: "Please enter number of buyers",

  // setting page
  val_enter_address: "Please Enter Address",

  // Length msg

  minlength_msg: "value must be minimum 2 characters",
  maxlength_personName: "value must be maximum 15 characters",
  maxlength_designation: "value must be maximum 15 characters",
  maxlength_designation1: "value must be maximum 30 characters",
  maxlength_msg: "value must be maximum",
  characters: " characters",
  fileSize5MB: "Upload PPT / PDF - Maximum file size: 2 MB",
  photoGalleryCondition: "Upload JPG/PNG  - Maximum 5 photos limit",

  // Notifications msg

  msg_login_successfull: "Login Successfully",
  msg_PasswordChangeSuccess: "Password Changed Successfully",
  err_EnterCorrectPassword: "Please Enter Correct Password",
  already_activated: "Your account is already activated!",
  msg_userUpdateSuccess: "User updated successfully",
  err_editProfile: "Error in edit profile",
  addUser_successfull: "User Created!",
  update_active_successfull:
    "User Activated Successfully and Credential detail emailed to User.",
  update_inactive_successfull: "User Deactivated and email sent",

  company_active_successfull:
    "Company Activated Successfully and Credential detail emailed to Company.",
  company_inactive_successfull: "Company Deactivated!",
  updatedCompanyDetailSuccessful: "Company Detail Updated successfully",
  companyDeleted: "Company deleted successfully",

  msg_addSubscriptionSuccess: "Subscription added successfully",
  msg_updateSubscriptionSuccess: "Subscription updated successfully",
  err_getSubscription: "Error in get subscription details",

  msg_addPurchasedSubscriptionSuccess:
    "Purchased Subscription added successfully",
  msg_updatePurchasedSubscriptionSuccess:
    "Purchased Subscription updated successfully",
  err_getPurchasedSubscription: "Error in get purchased subscription details",

  msg_addConciergeSuccess: "Concierge added successfully",
  msg_updateConciergeSuccess: "Concierge updated successfully",
  msg_ConciergeDeleted: "Concierge deleted successfully",

  msg_requestDeleted: "Request deleted successfully",
  msg_requestUpdated: "Request updated successfully",

  company_exsits: "Client name already exsits",
  location_exsits: "Mfg. Facility location already exsits",

  // Pop-ups

  // pop_delete: "Are You Sure To Delete ?",
  // pop_title: "Are you sure to archive ?",
  // pop_restore_title: "Are you sure to restore ?",
  // pop_photoTitle: "Are You Sure Archive This Image ?",
  pop_employee_status_message:
    "Are You Sure You Want To Change Employee Status ?",
  pop_company_status_message:
    "Are You Sure You Want To Change Company Status ?",
  pop_ok: "Yes",
  pop_cancel: "Cancel",
  pop_driver_status_message: "Are You Sure You Want To Change Driver Status ?",
  // confirmAlertFacility

  confirmAlertFacility_title: "Confirm to save change ?",
  confirmAlertFacility_message: "Are you sure want to save the change ?",
  confirmAlertFacility_ok: "Yes",
  confirmAlertFacility_cancel: "No",

  // confirmAlertBrowser

  confirmAlertBrowser_title: "Leave site?",
  confirmAlertBrowser_message: "Changes you made may not be saved.",
  confirmAlertBrowser_ok: "Leave",
  confirmAlertBrowser_cancel: "Cancel",

  // Send Inquiry
  more: "More",
  moreInfo: "More info",
  sendInquiry: "Send Inquiry",
  sendinquiry_from_email: "From Email",
  ph_sendinquiry_from_email: "From Email",
  sendinquiry_to_email: "Inquiry To",
  ph_sendinquiry_to_email: "Inquiry To",
  sendinquiry_subject: "Subject",
  ph_sendinquiry_subject: "Please enter subject",
  val_msg_sendinquiry_subject: "Please enter subject",
  sendinquiry_details: "Details",
  ph_sendinquiry_details: "Please enter details",
  val_msg_sendinquiry_details: "Please enter details",

  //Package Master
  // pl_sequence: "Sequence Number",
  // val_sequence: "Please Enter Sequence Number",
  pl_Route_ID: "Route ID",
  val_Route_ID: "Please Enter Route ID",
  pl_Route_Name: "Route Name",
  val_Route_Name: "Please Enter Route Name",
  pl_Route_Number: "Route Number",
  val_Route_Number: "Please Enter Route Number",
  pl_Route_Total_Distance: "Route Total Distance",
  val_Route_Total_Distance: "Please Enter Route Total Distance",
  pl_Route_Planned_Time: "Route Planned Time",
  val_Route_Planned_Time: "Please Select Route Planned Time",
  pl_Route_Address_Count: "Route Address Count",
  val_Route_Address_Count: "Please Enter Route Address Count",
  pl_Route_Planned_Total_Drive_Time: "Route Planned Total Drive Time",
  val_Route_Planned_Total_Drive_Time:
    "Please Select Route Planned Total Drive Time",
  pl_Route_Planned_Total_Service_Time: "Route Planned Total Service Time",
  val_Route_Planned_Total_Service_Time:
    "Please Select Route Planned Total Service Time",
  pl_Scheduled_For: "Scheduled For",
  val_Scheduled_For: "Please Select Scheduled For",
  pl_Planned_delivery_Start_Date: " Delivery start Date",
  val_Planned_delivery_Start_Date: "Please Select Delivery start Date",
  pl_Planned_delivery_Start_Time: "Delivery Start Time",
  val_Planned_delivery_Start_Time: "Please Select Delivery Start Time",
  pl_delivery_End_Date: "Delivery End Date",
  val_delivery_End_Date: "Please Select Delivery End Date",
  pl_delivery_End_Time: "Delivery End Time",
  val_delivery_End_Time: "Please Select Delivery End Time",
  pl_Stop_Status: "Stop Status",
  val_Stop_Status: "Please Enter Stop Status",

  pl_Stop_Status_Time_UTC: "Stop Status Time UTC",
  val_Stop_Status_Time_UTC: "Please Enter Stop Status Time UTC",

  pl_Stop_Status_Time: "Stop Status Time",
  val_Stop_Status_Time: "Please Enter Stop Status Time",

  pl_Geofence_Visited_Time: "Geofence Visited Time",
  val_Geofence_Visited_Time: "Please Enter Geofence Visited Time",

  pl_Geofence_Departed_Time: "Geofence Departed Time",
  val_Geofence_Departed_Time: "Please Enter Geofence Departed Time",

  pl_Geofence_Time_On_Site: "Geofence Time On Site",
  val_Geofence_Time_On_Site: "Please Enter Geofence Time On Site",

  pl_Geofence_Detected_Visited_Lat: "Geofence Detected Visited Lat",
  val_Geofence_Detected_Visited_Lat:
    "Please Enter Geofence Detected Visited Lat",

  pl_Geofence_Detected_Visited_Lng: "Geofence Detected Visited Lng",
  val_Geofence_Detected_Visited_Lng:
    "Please Enter Geofence Detected Visited Lng",

  pl_Geofence_Detected_Departed_Lat: "Geofence Detected Departed Lat",
  val_Geofence_Detected_Departed_Lat:
    "Please Enter Geofence Detected Departed Lat",

  pl_Geofence_Detected_Departed_Lng: "Geofence Detected Departed Lng",
  val_Geofence_Detected_Departed_Lng:
    "Please Enter Geofence Detected Departed Lng",

  pl_Geofence_Local_Visited_Time: "Geofence Local Visited Time",
  val_Geofence_Local_Visited_Time: "Please Enter Geofence Local Visited Time",

  pl_Geofence_Local_Departed_Time: "Geofence Local Departed Time",
  val_Geofence_Local_Departed_Time: "Please Enter Geofence Local Departed Time",

  pl_Geofence_Local_Time_On_Site: "Geofence Local Time On Site",
  val_Geofence_Local_Time_On_Site: "Please Enter Geofence Local Time On Site",

  pl_Geofence_Local_Visited_Lat: "Geofence Local Visited Lat",
  val_Geofence_Local_Visited_Lat: "Please Enter Geofence Local Visited Lat",

  pl_Geofence_Local_Visited_Lng: "Geofence Local Visited Lng",
  val_Geofence_Local_Visited_Lng: "Please Enter Geofence Local Visited Lng",

  pl_Geofence_Local_Departed_Lat: "Geofence Local Departed Lat",
  val_Geofence_Local_Departed_Lat: "Please Enter Geofence Local Departed Lat",

  pl_Geofence_Local_Departed_Lng: "Geofence Local Departed Lng",
  val_Geofence_Local_Departed_Lng: "Please Enter Geofence Local Departed Lng",

  pl_Actual_Travel_Distance: "Actual Travel Distance ",
  val_Actual_Travel_Distance: "Please Enter Actual Travel Distance ",

  pl_Actual_Travel_Time: "Actual Travel Time ",
  val_Actual_Travel_Time: "Please Enter Actual Travel Time ",

  pl_Expected_Actual_Distance_From_Previous_Stop:
    "Expected Actual Distance From Previous Stop",
  val_Expected_Actual_Distance_From_Previous_Stop:
    "Please Enter Expected Actual Distance From Previous Stop",

  pl_Expected_Actual_Time_From_Previous_Stop:
    "Expected Actual Time From Previous Stop",
  val_Expected_Actual_Time_From_Previous_Stop:
    "Please Enter Expected Actual Time From Previous Stop",

  pl_Expected_Actual_Running_Distance: "Expected Actual Running Distance",
  val_Expected_Actual_Running_Distance:
    "Please Enter Expected Actual Running Distance",

  pl_Expected_Actual_Running_Drive_Time: "Expected Actual Running Drive Time",
  val_Expected_Actual_Running_Drive_Time:
    "Please Enter Expected Actual Running Drive Time",

  pl_Expected_Actual_Running_Service_Time:
    "Expected Actual Running Service Time",
  val_Expected_Actual_Running_Service_Time:
    "Please Enter Expected Actual Running Service Time",

  pl_Actual_Distance_Computation_Method: "Actual Distance Computation Method",
  val_Actual_Distance_Computation_Method:
    "Please Enter Actual Distance Computation Method",

  pl_Actual_Drive_Time_Computation_Method:
    "Actual Drive Time Computation Method",
  val_Actual_Drive_Time_Computation_Method:
    "Please Enter Actual Drive Time Computation Method",

  pl_Actual_Arrival_Time_Computation_Method:
    "Actual Arrival Time Computation Method",
  val_Actual_Arrival_Time_Computation_Method:
    "Please Enter Actual Arrival Time Computation Method",

  pl_Actual_Departure_Time_Computation_Method:
    "Actual Departure Time Computation Method",
  val_Actual_Departure_Time_Computation_Method:
    "Please Enter Actual Departure Time Computation Method",

  pl_Actual_Service_Time_Computation_Method:
    "Actual Service Time Computation Method",
  val_Actual_Service_Time_Computation_Method:
    "Please Enter Actual Service Time Computation Method",

  pl_Expected_Actual_Time_From_Start: "Expected Actual Time From Start",
  val_Expected_Actual_Time_From_Start:
    "Please Enter Expected Actual Time From Start",

  pl_Expected_Actual_Distance_From_Start: "Expected Actual Distance From Start",
  val_Expected_Actual_Distance_From_Start:
    "Please Enter Expected Actual Distance From Start",

  pl_Total_Actual_Route_Distance: "Total Actual Route Distance",
  val_Total_Actual_Route_Distance: "Please Enter Total Actual Route Distance",

  pl_Total_Actual_Route_Time: "Total Actual Route Time",
  val_Total_Actual_Route_Time: "Please Enter Total Actual Route Time",

  pl_Alias: "Alias",
  val_Alias: "Please Enter Alias",

  pl_Address: "Address",
  val_Address: "Please Enter Address",

  pl_Address_Type: "Address Type",
  val_Address_Type: "Please Enter Address Type",

  pl_Address_Book_Group: "Address Book Group",
  val_Address_Book_Group: "Please Enter Address Book Group",

  pl_Customer_Purchase_Order: "Customer Purchase Order",
  val_Customer_Purchase_Order: "Please Enter Customer Purchase Order",

  pl_First_Name: "First Name",
  val_First_Name: "Please Enter First Name",

  pl_Last_Name: "Last Name",
  val_Last_Name: "Please Enter Last Name",

  pl_Email: "Email",
  val_Email: "Please Enter Email",

  pl_Phone: "Phone",
  val_Phone: "Please Enter Phone",

  pl_Address_Book_Last_Visited: "Address Book Last Visited",
  val_Address_Book_Last_Visited: "Please Enter Address Book Last Visited",

  pl_Address_Book_Last_Departed: "Address Book Last Departed",
  val_Address_Book_Last_Departed: "Please Enter Address Book Last Departed",

  pl_barcode: "Barcode",
  val_barcode: "Please Enter Barcode",
  pl_load_assist_id: "Load Assist ID",
  val_load_assist_id: "Please Enter Load Assist ID",
  pl_Note_Delivery_Type: "Note Delivery Type",
  val_Note_Delivery_Type: "Please Enter Note Delivery Type",
  pl_Note_Testfield: "Note Testfield",
  val_Note_Testfield: "Please Enter Note Testfield",
  pl_Priority: "Priority",
  val_Priority: "Please Enter Priority",
  pl_Invoice_Number: "Invoice Number",
  val_Invoice_Number: "Please Enter Invoice Number",
  pl_Reference_Number: "Reference Number",
  val_Reference_Number: "Please Enter Reference Number",
  pl_Order_Number: "Order Number",
  val_Order_Number: "Please Enter Order Number",
  // pl_Weight: "Weight",
  // val_Weight: "Please Enter Weight",
  pl_Height: "Height",
  val_Height: "Please Enter Height",
  pl_width: "Width",
  val_width: "Please Enter Width",
  pl_Length: "Length",
  val_Length: "Please Enter Length",
  pl_Volume_Weighted: "Volume Weighted",
  val_Volume_Weighted: "Please Enter Volume Weighted",
  pl_Cost: "Cost",
  val_Cost: "Please Enter Cost",
  pl_Revenue: "Revenue",
  val_Revenue: "Please Enter Revenue",
  pl_Cube: "Cube",
  val_Cube: "Please Enter Cube",
  pl_Pieces: "Pieces",
  val_Pieces: "Please Enter Pieces",
  pl_Tracking_Number: "Tracking Number",
  val_Tracking_Number: "Please Enter Tracking Number",
  pl_Service_Time: "Service Time",
  val_Service_Time: "Please Enter Service Time",
  pl_Note_Type: "Note Type",
  val_Note_Type: "Please Enter Note Type",
  pl_Note_Content: "Note Content",
  val_Note_Content: "Please Enter Note Content",
  pl_Note_Attachment_URL: "Note Attachment URL",
  val_Note_Attachment_URL: "Please Enter Note Attachment URL",
  pl_Note_Time: "Note Time",
  val_Note_Time: "Please Enter Note Time",
  pl_Note_Latitude: "Note Latitude",
  val_Note_Latitude: "Please Enter Note Latitude",
  pl_Note_Longitude: "Note Longitude",
  val_Note_Longitude: "Please Enter Note Longitude",
  pl_Planned_Destinations: "Planned Destinations",
  val_Planned_Destinations: "Please Enter Planned Destinations",
  pl_Failed_Destinations: "Failed Destinations",
  val_Failed_Destinations: "Please Enter Failed Destinations",
  pl_Done_Destinations: "Done Destinations",
  val_Done_Destinations: "Please Enter Done Destinations",
  pl_Running_Service_Time: "Running Service Time",
  val_Running_Service_Time: "Please Enter Running Service Time",
  pl_Running_Travel_Time: "Running Travel Time",
  val_Running_Travel_Time: "Please Enter Running Travel Time",
  pl_Running_Wait_Time: "Running Wait Time",
  val_Running_Wait_Time: "Please Enter Running Wait Time",
  pl_Route_Wait_Time: "Route Wait Time",
  val_Route_Wait_Time: "Please Enter Route Wait Time",
  pl_Running_Distance: "Running Distance",
  val_Running_Distance: "Please Enter Running Distance",
  pl_Stops_Per_On_Road_Hour: "Stops Per On-Road Hour",
  val_Stops_Per_On_Road_Hour: "Please Enter Stops Per On-Road Hour",
  pl_Transactions_Per_On_Road_Hour: "Transactions Per On-Road Hour",
  val_Transactions_Per_On_Road_Hour:
    "Please Enter Transactions Per On-Road Hour",
  pl_Time_Window_1_Start: "Time Window 1 Start",
  val_Time_Window_1_Start: "Please Enter Time Window 1 Start",
  pl_Time_Window_1_End: "Time Window 1 End",
  val_Time_Window_1_End: "Please Enter Time Window 1 End",
  pl_Time_Window_2_Start: "Time Window 2 Start",
  val_Time_Window_2_Start: "Please Enter Time Window 2 Start",
  pl_Time_Window_2_End: "Time Window 2 End",
  val_Time_Window_2_End: "Please Enter Time Window 2 End",
  pl_Optimized_Time_Window_Start: "Optimized Time Window Start",
  val_Optimized_Time_Window_Start: "Please Enter Optimized Time Window Start",
  pl_Optimized_Time_Window_End: "Optimized Time Window End",
  val_Optimized_Time_Window_End: "Please Enter Optimized Time Window End",
  pl_Planned_Arrival_Time: "Planned Arrival Time",
  val_Planned_Arrival_Time: "Please Enter Planned Arrival Time",
  pl_Planned_Departure_Time: "Planned Departure Time",
  val_Planned_Departure_Time: "Please Enter Planned Departure Time",
  pl_Predicted_Arrival_Time: "Predicted Arrival Time",
  val_Predicted_Arrival_Time: "Please Enter Predicted Arrival Time",
  pl_Predicted_Departure_Time: "Predicted Departure Time",
  val_Predicted_Departure_Time: "Please Enter Predicted Departure Time",
  pl_Time_Impact: "Time Impact",
  val_Time_Impact: "Please Enter Time Impact",
  pl_Route_Start_Button_Timestamp: "Route Start Button Timestamp",
  val_Route_Start_Button_Timestamp: "Please Enter Route Start Button Timestamp",
  pl_Route_End_Button_Timestamp: "Route End Button Timestamp",
  val_Route_End_Button_Timestamp: "Please Enter Route End Button Timestamp",
  pl_Time_From_Start_To_First_Destination:
    "Time From Start To First Destination",
  val_Time_From_Start_To_First_Destination:
    "Please Enter Time From Start To First Destination",
  pl_Time_From_Last_Destination_To_Start: "Time From Last Destination To Start",
  val_Time_From_Last_Destination_To_Start:
    "Please Enter Time From Last Destination To Start",
  pl_Remaining_Weight: "Remaining Weight",
  val_Remaining_Weight: "Please Enter Remaining Weight",
  pl_Remaining_Pieces: "Remaining Pieces",
  val_Remaining_Pieces: "Please Enter Remaining Pieces",
  pl_Remaining_Cube: "Remaining Cube",
  val_Remaining_Cube: "Please Enter Remaining Cube",
  pl_Total_Cost: "Total Cost",
  val_Total_Cost: "Please Enter Total Cost",
  pl_Total_Weight: "Total Weight",
  val_Total_Weight: "Please Enter Total Weight",
  pl_Total_Cube: "Total Cube",
  val_Total_Cube: "Please Enter Total Cube",
  pl_Total_Revenue: "Total Revenue",
  val_Total_Revenue: "Please Enter Total Revenue",
  pl_Total_Pieces: "Total Pieces",
  val_Total_Pieces: "Please Enter Total Pieces",
  pl_Weight_Remaining_At_End: "Weight Remaining At End",
  val_Weight_Remaining_At_End: "Please Enter Weight Remaining At End",
  pl_Cube_Remaining_At_End: "Cube Remaining At End",
  val_Cube_Remaining_At_End: "Please Enter Cube Remaining At End",
  pl_Revenue_Remaining_At_End: "Revenue Remaining At End",
  val_Revenue_Remaining_At_End: "Please Enter Revenue Remaining At End",
  pl_Pieces_Remaining_At_End: "Pieces Remaining At End",
  val_Pieces_Remaining_At_End: "Please Enter Pieces Remaining At End",
  pl_Weight_Completed: "Weight Completed",
  val_Weight_Completed: "Please Enter Weight Completed",
  pl_Cube_Completed: "Cube Completed",
  val_Cube_Completed: "Please Enter Cube Completed",
  pl_Revenue_Completed: "Revenue Completed",
  val_Revenue_Completed: "Please Enter Revenue Completed",
  pl_Pieces_Completed: "Pieces Completed",
  val_Pieces_Completed: "Please Enter Pieces Completed",
  pl_Marked_Arrival_Time: "Marked Arrival Time",
  val_Marked_Arrival_Time: "Please Enter Marked Arrival Time",
  pl_Marked_Departure_Time: "Marked Departure Time",
  val_Marked_Departure_Time: "Please Enter Marked Departure Time",
  pl_Marked_Stop_Time: "Marked Stop Time",
  val_Marked_Stop_Time: "Please Enter Marked Stop Time",
  pl_Departed: "Departed",
  val_Departed: "Please Enter Departed",
  pl_Departed_Latitude: "Departed Latitude",
  val_Departed_Latitude: "Please Enter Departed Latitude",
  pl_Departed_Longitude: "Departed Longitude",
  val_Departed_Longitude: "Please Enter Departed Longitude",
  pl_Distance_To_Next: "Distance To Next",
  val_Distance_To_Next: "Please Enter Distance To Next",
  pl_Drive_Time_To_Next: "Drive Time To Next",
  val_Drive_Time_To_Next: "Please Enter Drive Time To Next",
  pl_Actual_Arrival_Time_Computation: "Actual Arrival Time Computation",
  val_Actual_Arrival_Time_Computation:
    "Please Enter Actual Arrival Time Computation",
  pl_Actual_Departure_Time_Computation: "Actual Departure Time Computation",
  val_Actual_Departure_Time_Computation:
    "Please Enter Actual Departure Time Computation",
  pl_Actual_Arrival_Time: "Actual Arrival Time",
  val_Actual_Arrival_Time: "Please Enter Actual Arrival Time",
  // pl_Actual_Departure_Time: "Actual Departure Time",
  // val_Actual_Departure_Time: "Please Enter Actual Departure Time",
  // pl_Actual_Service_Time: "Actual Service Time",

  pl_Site: "Site",
  val_Site: "Please Enter Site",
  pl_Original_Planned_Qty: "Original Planned Quantity",
  val_Original_Planned_Qty: "Please Enter Original Planned Quantity",
  pl_Inventory_Sequence_No: "Inventory Sequence No",
  val_Inventory_Sequence_No: "Please Enter Inventory Sequence No",
  pl_Planned_Cost: "Planned Cost",
  val_Planned_Cost: "Please Enter Planned Cost",

  pl_Time_At_Site: "Time At Site",
  val_Time_At_Site: "Please Enter Time At Site",
  pl_Time_At_Resource: "Time At Resource",
  val_Time_At_Resource: "Please Enter Time At Resource",
  pl_Time_At_Work_Area: "Time At Work Area",
  val_Time_At_Work_Area: "Please Enter Time At Work Area",

  pl_Timeline: "Timeline",
  val_Timeline: "Please Enter Timeline",
  pl_Comments: "Comments",
  val_Comments: "Please Enter Comments",

  pl_Planned_Weight: "Planned Weight",
  val_Planned_Weight: "Please Enter Planned Weight",
  pl_Planned_Cube: "Planned Cube",
  val_Planned_Cube: "Please Enter Planned Cube",
  pl_archived_City: "Archived City",
  error_in_list_City: "Error in List City",
  pl_add_City: "Add City",
  // pl_add_pincode: "Add Pincode",
  // label_company_name: "Company Name",
  label_Work_on: "Work On",
  val_label_Work_on: "Please Select Work On",
  label_ABN_Number: "ABN Number",
  pl_abn_number: "12234432567",
  val_abn_number_2: "Please Enter Valid ABN Number",
  tax_file_number: "Tax File Number",
  val_tax_file_number_2: "Please Enter Valid TFN Number",
  label_emergency_contact_person_name: "Emergency Contact Person Name",
  pl_emergency_contact_person_name: "Emergency Contact Person Name",
  label_emergency_contact_person_no: "Emergency Contact Person No",
  label_bank_detail: "Account Holder Name",
  pl_label_bank_detail: "Enter Account Holder Name",
  pl_bank_detail_2: "Please Enter Bank Detail",
  label_bank_account_number: "Account Number",
  pl_bank_account_no_2: "Enter Bank Account Number",
  label_driving_license: "Driving License",
  pl_upload_driving_licence: "Please Upload Your Driving License!",
  label_police_check: "Police Check",
  pl_upload_police_check: "Please Upload Your Police Check!",
  label_Visa: "Visa",
  val_label_Visa: "Please Upload Visa",
  label_passport: "Passport",
  val_label_passport: "Please Upload Your Passport!",
  label_Visa_type: "Permanent Resident",
  label_company_type: "Company Type",
  pl_label_Visa_type: "Enter Permanent Resident",
  pl_company_type: "Enter Company Type",
  val_label_Visa_type: "Please Select Permanent Resident",
  val_company_type: "Please Select Company type",
  label_term_condition_accept: "Term And Condition Accept",

  // pl_company_name: "Please Enter Company Name",
  label_tax_file_number: "Tax File Number",
  pl_tax_file_number_2: "856963214",
  label_bank_branch: "Branch Name",
  pl_bank_branch: "Enter Branch Name",
  val_bank_detail_2: "Please Enter Account Holder Name",
  val_bank_account_no_2: "Please Enter Account Number",
  val_bank_branch: "Please Enter Branch Name",
  // label_Address: "Address",
  pl_address_2: "Enter Flat, House no., Building",
  // pl_country: "Country",
  country: "Select Country ",
  pl_edit_country: "Edit Country ",
  // pl_select_country: "Select Country",
  city_archive_successfully: "City archived successfully",
  error_in_restore_city: "Error in restored City",

  packageList: "Package List",
  pl_packageListing: "Package List",
  packagePickupList: "Pickup Package List",
  pl_packagePickUpListing: "Pickup Package List",
  pl_email_driver: "Enter Driver's Email",
  val_email_driver: "Please Enter Driver Email",
  add_package: "Add Package",
  // error_in_updating_driver:"Error in updating driver",
  // error_in_adding_driver:"Error in adding driver",

  add_driver: "Add Driver",
  // driver_added_successfully: "Driver added successfully",
  // driver_updated_successfully: "Driver updated successfully",
  error_in_list_package: "Error In List Package",
  package_restore_successfully: "Package Restore Successfully",
  error_in_restore_package: "Error In Restore Package",
  package_archive_successfully: "Package Archived Successfully",
  // error_in_delete_employee: "Error in delete employee",
  error_in_delete_package: "Error In Delete Package",
  pl_add_package: "Add Package",
  archived_package_list: "Archived Package List",
  archived_pickup_package_list: "Archived Pickup Package List",
};
